import React, { useState, useEffect } from 'react';
import {
  RotateCcw, Home, AlertCircle, Filter, Users, DollarSign,
  TrendingUp, Eye, Phone, Mail, GraduationCap, BookOpen,
  UserCheck, Building, Calendar, Target, BarChart3, Award,
  Shield, CheckCircle, XCircle, User, Search, Download, Handshake, Clock,
  Edit2, Save, X, Plus, Trash2
} from 'lucide-react';
import ActivitesManagement from '../components/ActivitesManagement';
import StudentPaymentsTracker from '../components/StudentPaymentsTracker';
import AutoMissionModal from '../components/AutoMissionModal';
import CommissionsCommercialesComponent from '../components/CommissionsCommercialesComponent';
import TdbPedagogiqueComponent from '../components/TdbPedagogiqueComponent';
import Sidebar from '../components/Sidebar';
import DesistementsComponent from '../components/Desistementscard';
import MonthlyRevenueTracker from '../components/MonthlyRevenueTracker';
import MonthlyInscriptionsTracker from '../components/MonthlyInscriptionsTracker';

const DashboardNormal = () => {
  const [etudiants, setEtudiants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [partners, setPartners] = useState([]);
  const [statsPartners, setStatsPartners] = useState([]);
  const [anneeScolaireFilter, setAnneeScolaireFilter] = useState('2026/2027');
  const [anneesDisponibles, setAnneesDisponibles] = useState([]);
  const [commerciaux, setCommerciaux] = useState([]);
  const [statistiques, setStatistiques] = useState([]);

  // Ajout de l'état pour le CA des missions
  const [chiffreAffaireMissions, setChiffreAffaireMissions] = useState(0);

  const [chiffreAffaire, setChiffreAffaire] = useState({
    nouveauxInscrits: { count: 0, ca: 0 },
    reinscriptions: { count: 0, ca: 0 },
    transferes: { count: 0, ca: 0 },
    total: { count: 0, ca: 0 },
    recouvrement: { percentage: 0, ca: 0 }
  });

  const [tableauInscrits, setTableauInscrits] = useState({
    global: { total: 0, fi: 0, ta: 0, executive: 0, ca: 0 },
    fi: { total: 0, masi: 0, irm: 0, cycleIngenieur: 0, genieCivil: 0, mecatronique: 0, master: 0, autre: 0, ca: 0 },
    executive: { total: 0, masi: 0, irm: 0, autre: 0, licencePro: 0, masterPro: 0, ca: 0 },
    ta: { total: 0, masi: 0, irm: 0, cycleIngenieur: 0, genieCivil: 0, mecatronique: 0, master: 0, autre: 0, ca: 0 }
  });

  const [tableauReinscriptions, setTableauReinscriptions] = useState({
    global: { total: 0, fi: 0, ta: 0, executive: 0, ca: 0 },
    fi: { total: 0, masi: 0, irm: 0, cycleIngenieur: 0, genieCivil: 0, mecatronique: 0, master: 0, autre: 0, ca: 0 },
    executive: { total: 0, masi: 0, irm: 0, autre: 0, licencePro: 0, masterPro: 0, ca: 0 },
    ta: { total: 0, masi: 0, irm: 0, cycleIngenieur: 0, genieCivil: 0, mecatronique: 0, master: 0, autre: 0, ca: 0 }
  });

  const [preinscriptions, setPreinscriptions] = useState({
    count: 0,
    parType: {
      fi: 0,
      ta: 0,
      executive: 0
    },
    parFiliere: {},
    parCommercial: {}
  });

  const [partnerChiffres, setPartnerChiffres] = useState([]);
  const [editingPartnerId, setEditingPartnerId] = useState(null);
  const [editValues, setEditValues] = useState({});

  const [desistements, setDesistements] = useState({
    total: 0,
    parRaison: {},
    parType: { fi: 0, ta: 0, executive: 0 },
    parFiliere: {},
    evolution: []
  });

  const [partnersTotalStats, setPartnersTotalStats] = useState({
    totalStudents: 0,
    totalRevenue: 0
  });

  // DONNÉES FIXES POUR 2024/2025 UNIQUEMENT
  const donneesFixes2024_2025 = {
    chiffreAffaire: {
      nouveauxInscrits: { count: 202, ca: 5410608.98 },
      reinscriptions: { count: 47, ca: 1306440.0 },
      transferes: { count: 0, ca: 0 },
      total: { count: 249, ca: 6717048.98 },
      recouvrement: { percentage: 56.64, ca: 3949767.74 }
    },
    tableauInscrits: {
      global: { total: 202, fi: 59, ta: 53, executive: 90, ca: 5410608.98 },
      fi: { total: 59, masi: 15, irm: 44, cycleIngenieur: 0, ca: 1731608.98 },
      executive: { total: 90, masi: 19, irm: 42, autre: 29, licencePro: 0, masterPro: 0, ca: 2299000.0 },
      ta: { total: 53, masi: 26, irm: 27, cycleIngenieur: 0, ca: 1380000.0 }
    },
    tableauReinscriptions: {
      global: { total: 47, fi: 33, ta: 14, executive: 0, ca: 1306440.0 },
      fi: { total: 33, masi: 7, irm: 26, cycleIngenieur: 0, ca: 928440.0 },
      executive: { total: 0, masi: 0, irm: 0, autre: 0, licencePro: 0, masterPro: 0, ca: 0.0 },
      ta: { total: 14, masi: 10, irm: 4, cycleIngenieur: 0, ca: 378000.0 }
    }
  };

  // DONNÉES FIXES POUR 2025/2026 UNIQUEMENT
  const donneesFixes2025_2026 = {
    chiffreAffaire: {
      nouveauxInscrits: {
        count: 332,
        ca: 11047319,
        maroc: { count: 281, ca: 9163246 },
        afrique: { count: 51, ca: 1884073 }
      },
      reinscriptions: { count: 74, ca: 2200877 },
      transferes: { count: 6, ca: 175000 },
      totalPartners: { count: 989, ca: 10266000 },
      total: { count: 1401, ca: 23689196 },
      recouvrement: { percentage: 12.15, ca: 1609850 }
    },
    tableauInscrits: {
      global: { total: 332, fi: 171, ta: 92, executive: 69, ca: 11047319 },
      fi: { total: 171, masi: 46, irm: 89, cycleIngenieur: 35, ca: 6008819 },
      executive: { total: 69, masi: 0, irm: 0, autre: 1, licencePro: 23, masterPro: 45, ca: 2018000 },
      ta: { total: 92, masi: 26, irm: 62, cycleIngenieur: 4, ca: 3020500 }
    },
    tableauReinscriptions: {
      global: { total: 74, fi: 57, ta: 16, executive: 1, ca: 2200877 },
      fi: { total: 57, masi: 8, irm: 19, cycleIngenieur: 1, ca: 1692826 },
      executive: { total: 1, masi: 0, irm: 0, autre: 0, licencePro: 0, masterPro: 1, ca: 30000 },
      ta: { total: 16, masi: 0, irm: 1, cycleIngenieur: 0, ca: 478051 }
    },
    partnersTotalStats: {
      totalStudents: 989,
      totalRevenue: 10266000
    },
    commercialStats: [
      {
        nom: "Aicha Achaf",
        email: "achraf@gmail.com",
        telephone: "0",
        chiffreAffaire: 5456073,
        totalRecu: 418073,
        reste: 5038000,
        countEtudiants: 159,
        nouveaux: 158,
        reinscriptions: 1,
        actif: true,
        estAdminInscription: false
      },
      {
        nom: "Ismael El Kadmiri",
        email: "ismaelben88@gmail.com",
        telephone: "45555555555",
        chiffreAffaire: 4956246,
        totalRecu: 637000,
        reste: 4319246,
        countEtudiants: 155,
        nouveaux: 148,
        reinscriptions: 7,
        actif: true,
        estAdminInscription: false
      },
      {
        nom: "Amina",
        email: "amina@supemir.com",
        telephone: "000000000",
        chiffreAffaire: 199000,
        totalRecu: 66000,
        reste: 133000,
        countEtudiants: 6,
        nouveaux: 5,
        reinscriptions: 1,
        actif: true,
        estAdminInscription: false
      },
      {
        nom: "Khaoula",
        email: "Khaoula@supemir.com",
        telephone: "000000000",
        chiffreAffaire: 66000,
        totalRecu: 0,
        reste: 66000,
        countEtudiants: 2,
        nouveaux: 2,
        reinscriptions: 0,
        actif: true,
        estAdminInscription: false
      },
      {
        nom: "Fatima zohrar Rhanem",
        email: "fatimazohrarhanem6@gmail.com",
        telephone: "0",
        chiffreAffaire: 34000,
        totalRecu: 0,
        reste: 34000,
        countEtudiants: 1,
        nouveaux: 1,
        reinscriptions: 0,
        actif: true,
        estAdminInscription: false
      }
    ],
    preinscriptionsStats: {
      count: 8,
      parType: { fi: 7, ta: 1, executive: 0 },
      parFiliere: { IRM: 7, MASI: 1 },
      parCommercial: { "Ismael El Kadmiri": 2 }
    }
  };

  // Fonction pour récupérer le CA des missions - CORRIGÉE
  const fetchChiffreAffaireMissions = async (anneeFilter) => {
    try {
      const token = localStorage.getItem('token');

      // Récupérer TOUTES les missions (pas de filtre par anneeScolaire)
      const res = await fetch(
        `     https://vmi1977988.contaboserver.net/api2/admin/fiches-mission`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = await res.json();

      if (data.success && data.data) {
        // Calculer le CA total des missions approuvées/remboursées
        let totalCA = 0;

        // Déterminer les dates de début/fin pour l'année scolaire
        let anneeDebut, anneeFin;
        if (anneeFilter === '2025/2026') {
          anneeDebut = new Date('2025-09-01');
          anneeFin = new Date('2026-08-31');
        } else if (anneeFilter === '2024/2025') {
          anneeDebut = new Date('2024-09-01');
          anneeFin = new Date('2025-08-31');
        } else if (anneeFilter === 'toutes') {
          // Pour "toutes les années", pas de filtre par date
          anneeDebut = null;
          anneeFin = null;
        } else {
          // Pour les autres années, essayer de parser
          const anneeMatch = anneeFilter.match(/(\d{4})\/(\d{4})/);
          if (anneeMatch) {
            anneeDebut = new Date(`${anneeMatch[1]}-09-01`);
            anneeFin = new Date(`${anneeMatch[2]}-08-31`);
          } else {
            // Si on ne peut pas déterminer, on prend toutes les missions
            anneeDebut = null;
            anneeFin = null;
          }
        }

        data.data.forEach(fiche => {
          if (fiche.statut === 'Approuvé' || fiche.statut === 'Remboursé') {
            // Vérifier si la mission est dans l'année scolaire
            if (fiche.dateDepart && anneeDebut && anneeFin) {
              const dateMission = new Date(fiche.dateDepart);

              // Si la mission n'est pas dans l'année scolaire, on la saute
              if (dateMission < anneeDebut || dateMission > anneeFin) {
                return;
              }
            }

            let coutMission = 0;

            // Frais de mission
            if (fiche.fraisMission) {
              if (fiche.fraisMission.repas?.plafond) {
                coutMission += fiche.fraisMission.repas.plafond * (fiche.nombreJours || 0);
              }
              if (fiche.fraisMission.hotel?.plafond) {
                coutMission += fiche.fraisMission.hotel.plafond * (fiche.nombreJours || 0);
              }
              if (fiche.fraisMission.transport?.plafond) {
                coutMission += fiche.fraisMission.transport.plafond;
              }
              if (fiche.fraisMission.autres?.plafond) {
                coutMission += fiche.fraisMission.autres.plafond;
              }
            }

            // Avance sur frais
            if (fiche.avanceSurFrais?.active && fiche.avanceSurFrais.montant) {
              coutMission += fiche.avanceSurFrais.montant;
            }

            totalCA += coutMission;
          }
        });

        setChiffreAffaireMissions(totalCA);
      }
    } catch (err) {
      console.error('Erreur chargement CA missions:', err);
      setChiffreAffaireMissions(0);
    }
  };

  const fetchStatistiques = async (anneeFilter = null) => {
    try {
      const token = localStorage.getItem('token');

      const anneeActuelle = anneeFilter || anneeScolaireFilter;

      if (anneeActuelle === '2024/2025') {
        setStatistiques([]);
        return;
      }

      if (anneeActuelle === '2025/2026') {
        setStatistiques(donneesFixes2025_2026.commercialStats);
        return;
      }

      calculerStatistiquesCommerciaux(anneeActuelle);

    } catch (error) {
      console.error('Erreur lors du chargement des statistiques:', error);
      setStatistiques([]);
    }
  };

  const calculerStatistiquesCommerciaux = (anneeFilter) => {
    const etudiantsFiltres = anneeFilter === 'toutes'
      ? etudiants.filter(e => e.isPartner !== true)
      : etudiants.filter(e => e.anneeScolaire === anneeFilter && e.isPartner !== true);

    const statsParCommercial = {};

    etudiantsFiltres.forEach(etudiant => {
      const commercialId = etudiant.commercial || 'inconnu';

      if (!statsParCommercial[commercialId]) {
        const commercial = commerciaux.find(c => c._id === commercialId);

        statsParCommercial[commercialId] = {
          nom: commercial ? commercial.nom : 'Commercial inconnu',
          email: commercial ? commercial.email : '',
          telephone: commercial ? commercial.telephone : '',
          chiffreAffaire: 0,
          totalRecu: 0,
          reste: 0,
          countEtudiants: 0,
          nouveaux: 0,
          reinscriptions: 0,
          actif: commercial ? commercial.actif !== false : true,
          estAdminInscription: commercial ? commercial.estAdminInscription || false : false
        };
      }

      const prixTotal = parseFloat(etudiant.prixTotal) || 0;
      statsParCommercial[commercialId].chiffreAffaire += prixTotal;
      statsParCommercial[commercialId].countEtudiants += 1;

      if (etudiant.nouvelleInscription === true) {
        statsParCommercial[commercialId].nouveaux += 1;
      } else {
        statsParCommercial[commercialId].reinscriptions += 1;
      }

      if (etudiant.paye) {
        statsParCommercial[commercialId].totalRecu += prixTotal;
      } else {
        statsParCommercial[commercialId].reste += prixTotal;
      }
    });

    const statistiquesCalculees = Object.entries(statsParCommercial)
      .filter(([commercialId, stats]) => commercialId !== 'inconnu')
      .map(([commercialId, stats]) => stats)
      .sort((a, b) => b.chiffreAffaire - a.chiffreAffaire);

    setStatistiques(statistiquesCalculees);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');

      const [etudiantsRes, commerciauxRes, partnersRes] = await Promise.all([
        fetch('    https://vmi1977988.contaboserver.net/api2/etudiant', {
          headers: { Authorization: `Bearer ${token}` }
        }),
        fetch('    https://vmi1977988.contaboserver.net/api2/commerciaux', {
          headers: { Authorization: `Bearer ${token}` }
        }),
        fetch('    https://vmi1977988.contaboserver.net/api2/partners', {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);

      if (!etudiantsRes.ok) {
        throw new Error(`Erreur étudiants: ${etudiantsRes.status} ${etudiantsRes.statusText}`);
      }
      if (!commerciauxRes.ok) {
        throw new Error(`Erreur commerciaux: ${commerciauxRes.status} ${commerciauxRes.statusText}`);
      }
      if (!partnersRes.ok) {
        console.warn(`Partners endpoint failed: ${partnersRes.status} ${partnersRes.statusText}`);
      }

      const etudiantsData = await etudiantsRes.json();
      const commerciauxData = await commerciauxRes.json();

      let partnersData = [];
      if (partnersRes.ok) {
        try {
          const partnersResponse = await partnersRes.json();
          if (partnersResponse.success && Array.isArray(partnersResponse.data)) {
            partnersData = partnersResponse.data;
          } else if (Array.isArray(partnersResponse)) {
            partnersData = partnersResponse;
          } else {
            console.warn('Format de données partners inattendu:', partnersResponse);
            partnersData = [];
          }
          console.log('Partners data loaded:', partnersData.length, 'partners');
        } catch (parseError) {
          console.warn('Failed to parse partners data:', parseError);
          partnersData = [];
        }
      }

      if (!Array.isArray(etudiantsData)) {
        throw new Error('Les données étudiants ne sont pas dans le format attendu');
      }
      if (!Array.isArray(commerciauxData)) {
        throw new Error('Les données commerciaux ne sont pas dans le format attendu');
      }

      setEtudiants(etudiantsData);
      setCommerciaux(commerciauxData);
      setPartners(partnersData);

      let annees = [...new Set(etudiantsData.map((e) => e.anneeScolaire).filter(Boolean))];

      // Ajouter 2026/2027 s'il n'est pas déjà présent (pour la planification)
      if (!annees.includes('2026/2027')) {
        annees.push('2026/2027');
      }

      annees.sort().reverse();
      setAnneesDisponibles(annees);

      let anneeASelectionner = anneeScolaireFilter;
      if (!anneeASelectionner && annees.length > 0) {
        if (annees.includes('2026/2027')) {
          anneeASelectionner = '2026/2027';
        } else if (annees.includes('2025/2026')) {
          anneeASelectionner = '2025/2026';
        } else {
          anneeASelectionner = annees[0];
        }
        setAnneeScolaireFilter(anneeASelectionner);
      }

      calculerStatistiquesAvecAnnee(etudiantsData, anneeASelectionner || anneeScolaireFilter, partnersData);
      calculerStatistiquesCommerciauxDirectement(etudiantsData, commerciauxData, anneeASelectionner || anneeScolaireFilter);
      calculerPreinscriptionsDirectement(etudiantsData, commerciauxData, anneeASelectionner || anneeScolaireFilter);
      calculerStatistiquesPartnersDirectement(etudiantsData, partnersData, anneeASelectionner || anneeScolaireFilter);
      calculerDesistementsDirectement(etudiantsData, anneeASelectionner || anneeScolaireFilter);

      // Ajout de l'appel pour récupérer le CA des missions - CORRECT
      await fetchChiffreAffaireMissions(anneeASelectionner || anneeScolaireFilter);
      await fetchPartnerChiffres(anneeASelectionner || anneeScolaireFilter);

    } catch (err) {
      console.error('Erreur lors du chargement des données:', err);
      setError(`Impossible de charger les données: ${err.message}`);
      setEtudiants([]);
      setCommerciaux([]);
      setPartners([]);
    } finally {
      setLoading(false);
    }
  };

  const calculerStatistiquesPartnersDirectement = (etudiantsData, partnersData, anneeFilter) => {
    if (!Array.isArray(partnersData)) {
      console.warn('partnersData is not an array:', partnersData);
      setStatsPartners([]);
      setPartnersTotalStats({ totalStudents: 0, totalRevenue: 0 });
      return;
    }

    const etudiantsFiltres = anneeFilter === 'toutes'
      ? etudiantsData.filter(e => e.isPartner === true)
      : etudiantsData.filter(e => e.anneeScolaire === anneeFilter && e.isPartner === true);

    const statsParPartner = {};

    etudiantsFiltres.forEach(etudiant => {
      const partnerId = (etudiant.partner?._id || etudiant.partner) || 'inconnu';

      if (!statsParPartner[partnerId]) {
        const partner = partnersData.find(p => p._id === partnerId);

        statsParPartner[partnerId] = {
          nomPartner: partner ? partner.nomPartner : 'Partner inconnu',
          email: partner ? partner.email : '',
          chiffreAffaire: 0,
          totalRecu: 0,
          reste: 0,
          countEtudiants: 0,
          nouveauxInscrits: 0,
          reinscriptions: 0,
          active: partner ? partner.active !== false : true
        };
      }

      const prixPartner = parseFloat(etudiant.prixTotalPartner) || 0;
      statsParPartner[partnerId].chiffreAffaire += prixPartner;
      statsParPartner[partnerId].countEtudiants += 1;

      if (etudiant.nouvelleInscription === true) {
        statsParPartner[partnerId].nouveauxInscrits += 1;
      } else {
        statsParPartner[partnerId].reinscriptions += 1;
      }

      if (etudiant.paye) {
        statsParPartner[partnerId].totalRecu += prixPartner;
      } else {
        statsParPartner[partnerId].reste += prixPartner;
      }
    });

    const statistiquesCalculees = Object.entries(statsParPartner)
      .filter(([partnerId, stats]) => partnerId !== 'inconnu')
      .map(([partnerId, stats]) => stats)
      .filter(stats => stats.nomPartner && stats.nomPartner.toLowerCase().trim() !== 'partner inconnu')
      .sort((a, b) => b.chiffreAffaire - a.chiffreAffaire);

    const totalStudents = statistiquesCalculees.reduce((sum, p) => sum + p.countEtudiants, 0);
    const totalRevenue = statistiquesCalculees.reduce((sum, p) => sum + p.chiffreAffaire, 0);

    setStatsPartners(statistiquesCalculees);
    setPartnersTotalStats({ totalStudents, totalRevenue });
  };

  const calculerStatistiquesCommerciauxDirectement = (etudiantsData, commerciauxData, anneeFilter) => {
    if (anneeFilter === '2024/2025') {
      setStatistiques([]);
      return;
    }
    if (anneeFilter === '2025/2026') {
      setStatistiques(donneesFixes2025_2026.commercialStats);
      return;
    }

    const etudiantsFiltres = anneeFilter === 'toutes'
      ? etudiantsData.filter(e => e.isPartner !== true)
      : etudiantsData.filter(e => e.anneeScolaire === anneeFilter && e.isPartner !== true);

    const statsParCommercial = {};

    etudiantsFiltres.forEach(etudiant => {
      const commercialId = etudiant.commercial || 'inconnu';

      if (!statsParCommercial[commercialId]) {
        const commercial = commerciauxData.find(c => c._id === commercialId);

        statsParCommercial[commercialId] = {
          nom: commercial ? commercial.nom : 'Commercial inconnu',
          email: commercial ? commercial.email : '',
          telephone: commercial ? commercial.telephone : '',
          chiffreAffaire: 0,
          totalRecu: 0,
          reste: 0,
          countEtudiants: 0,
          nouveaux: 0,
          reinscriptions: 0,
          actif: commercial ? commercial.actif !== false : true,
          estAdminInscription: commercial ? commercial.estAdminInscription || false : false
        };
      }

      const prixTotal = parseFloat(etudiant.prixTotal) || 0;
      statsParCommercial[commercialId].chiffreAffaire += prixTotal;
      statsParCommercial[commercialId].countEtudiants += 1;

      if (etudiant.nouvelleInscription === true) {
        statsParCommercial[commercialId].nouveaux += 1;
      } else {
        statsParCommercial[commercialId].reinscriptions += 1;
      }

      if (etudiant.paye) {
        statsParCommercial[commercialId].totalRecu += prixTotal;
      } else {
        statsParCommercial[commercialId].reste += prixTotal;
      }
    });

    const statistiquesCalculees = Object.entries(statsParCommercial)
      .filter(([commercialId, stats]) => commercialId !== 'inconnu')
      .map(([commercialId, stats]) => stats)
      .filter(stats => {
        const nomLower = stats.nom?.toLowerCase() || '';
        return !nomLower.includes('serti') && !nomLower.includes('najat');
      })
      .sort((a, b) => b.chiffreAffaire - a.chiffreAffaire);

    setStatistiques(statistiquesCalculees);
  };

  const analyseFilieres = () => {
    const etudiantsFiltres = anneeScolaireFilter === 'toutes'
      ? etudiants.filter(e => e.isPartner !== true)
      : etudiants.filter(e => e.anneeScolaire === anneeScolaireFilter && e.isPartner !== true);

    const filieresStats = {};

    etudiantsFiltres.forEach(e => {
      const filiere = e.filiere || 'Non définie';
      if (!filieresStats[filiere]) {
        filieresStats[filiere] = {
          etudiants: [],
          total: 0,
          payes: 0,
          ca: 0,
          caPaye: 0,
          specialites: new Set(),
          nouveaux: 0,
          reinscriptions: 0,
          actifs: 0,
          residents: 0,
          bourses: 0
        };
      }

      filieresStats[filiere].etudiants.push(e);
      filieresStats[filiere].total += 1;
      if (e.paye) filieresStats[filiere].payes += 1;
      if (e.actif) filieresStats[filiere].actifs += 1;
      if (e.resident) filieresStats[filiere].residents += 1;
      if (e.pourcentageBourse && e.pourcentageBourse > 0) filieresStats[filiere].bourses += 1;

      const prixTotal = parseFloat(e.prixTotal) || 0;
      filieresStats[filiere].ca += prixTotal;
      if (e.paye) filieresStats[filiere].caPaye += prixTotal;

      if (e.nouvelleInscription === true) filieresStats[filiere].nouveaux += 1;
      else filieresStats[filiere].reinscriptions += 1;

      if (e.specialite) filieresStats[filiere].specialites.add(e.specialite);
      if (e.specialiteIngenieur) filieresStats[filiere].specialites.add(e.specialiteIngenieur);
    });

    return Object.entries(filieresStats).map(([filiere, stats]) => ({
      filiere,
      ...stats,
      specialitesCount: stats.specialites.size,
      specialitesList: Array.from(stats.specialites),
      tauxPaiement: stats.total > 0 ? ((stats.payes / stats.total) * 100).toFixed(1) : 0,
      tauxActivite: stats.total > 0 ? ((stats.actifs / stats.total) * 100).toFixed(1) : 0,
      prixMoyen: stats.total > 0 ? (stats.ca / stats.total).toFixed(0) : 0,
      tauxNouveaux: stats.total > 0 ? ((stats.nouveaux / stats.total) * 100).toFixed(1) : 0
    })).sort((a, b) => b.total - a.total);
  };

  const calculerStatistiques = (data) => {
    calculerStatistiquesAvecAnnee(data, anneeScolaireFilter);
  };

  const calculerStatistiquesAvecAnnee = (data, anneeFilter, partnersData = []) => {
    if (anneeFilter === '2024/2025') {
      setChiffreAffaire(donneesFixes2024_2025.chiffreAffaire);
      setTableauInscrits(donneesFixes2024_2025.tableauInscrits);
      setTableauReinscriptions(donneesFixes2024_2025.tableauReinscriptions);
      setPartnersTotalStats({ totalStudents: 0, totalRevenue: 0 });
      return;
    }

    if (anneeFilter === '2025/2026') {
      setChiffreAffaire(donneesFixes2025_2026.chiffreAffaire);
      setTableauInscrits(donneesFixes2025_2026.tableauInscrits);
      setTableauReinscriptions(donneesFixes2025_2026.tableauReinscriptions);
      setPartnersTotalStats(donneesFixes2025_2026.partnersTotalStats);
      return;
    }

    const toNum = (v) => (v === null || v === undefined || v === '' ? 0 : parseFloat(v) || 0);

    const etudiantsFiltres = data.filter((e) =>
      (anneeFilter === 'toutes' || e.anneeScolaire === anneeFilter)
      && e.isPartner !== true
      && e.desistement?.statut !== true
      && e.desistement?.statut !== 'true'
    );

    const etudiantsActifs = etudiantsFiltres.filter((e) => e.actif !== false);
    const etudiantsTransferes = etudiantsFiltres.filter((e) => e.actif === false);

    const nouveauxInscrits = etudiantsActifs.filter((e) =>
      e.nouvelleInscription === true && toNum(e.prixTotal) > 0
    );

    const reinscriptions = etudiantsActifs.filter((e) =>
      e.nouvelleInscription === false && toNum(e.prixTotal) > 0
    );

    const caNouveau = nouveauxInscrits.reduce((sum, e) => sum + toNum(e.prixTotal), 0);
    const caReinscription = reinscriptions.reduce((sum, e) => sum + toNum(e.prixTotal), 0);
    const caTransferes = etudiantsTransferes.reduce((sum, e) => sum + toNum(e.prixTotal), 0);

    const etudiantsPartners = data.filter(
      (e) => (anneeFilter === 'toutes' || e.anneeScolaire === anneeFilter) && e.isPartner === true
    );

    const statsParPartner = {};
    etudiantsPartners.forEach(etudiant => {
      const partnerId = etudiant.partner?._id || etudiant.partner;
      if (!partnerId) return;

      if (!statsParPartner[partnerId]) {
        const partner = partnersData.find(p => p._id === partnerId);

        if (!partner) {
          console.warn(`Partner ${partnerId} non trouvé pour l'étudiant ${etudiant.prenom} ${etudiant.nomDeFamille}`);
          return;
        }

        statsParPartner[partnerId] = {
          nomPartner: partner.nomPartner,
          count: 0,
          ca: 0
        };
      }

      statsParPartner[partnerId].count += 1;
      statsParPartner[partnerId].ca += toNum(etudiant.prixTotalPartner);
    });

    const listePartners = Object.values(statsParPartner).sort((a, b) => b.ca - a.ca);
    const totalPartnersCount = listePartners.reduce((sum, p) => sum + p.count, 0);
    const totalPartnersCA = listePartners.reduce((sum, p) => sum + p.ca, 0);

    const caTotal = caNouveau + caReinscription + totalPartnersCA;

    const tousEtudiantsPayes = [...nouveauxInscrits, ...reinscriptions].filter((e) => e.paye === true);
    const caRecouvre = tousEtudiantsPayes.reduce((sum, e) => sum + toNum(e.prixTotal), 0);

    const nouveauxInscritsMaroc = nouveauxInscrits.filter(e => (e.pays || '').toLowerCase() === 'maroc');
    const nouveauxInscritsAfrique = nouveauxInscrits.filter(e => (e.pays || '').toLowerCase() !== 'maroc');

    const caNouveauMaroc = nouveauxInscritsMaroc.reduce((sum, e) => sum + toNum(e.prixTotal), 0);
    const caNouveauAfrique = nouveauxInscritsAfrique.reduce((sum, e) => sum + toNum(e.prixTotal), 0);

    setChiffreAffaire({
      nouveauxInscrits: {
        count: nouveauxInscrits.length,
        ca: caNouveau,
        maroc: { count: nouveauxInscritsMaroc.length, ca: caNouveauMaroc },
        afrique: { count: nouveauxInscritsAfrique.length, ca: caNouveauAfrique }
      },
      reinscriptions: { count: reinscriptions.length, ca: caReinscription },
      transferes: { count: etudiantsTransferes.length, ca: caTransferes },
      partners: listePartners,
      totalPartners: { count: totalPartnersCount, ca: totalPartnersCA },
      total: {
        count: nouveauxInscrits.length + reinscriptions.length + etudiantsTransferes.length + totalPartnersCount,
        ca: caTotal + caTransferes
      },
      recouvrement: {
        percentage: (caTotal + caTransferes) > 0 ? (caRecouvre / (caTotal + caTransferes)) * 100 : 0,
        ca: caRecouvre
      }
    });

    setPartnersTotalStats({
      totalStudents: totalPartnersCount,
      totalRevenue: totalPartnersCA
    });

    calculerTableauInscrits(nouveauxInscrits, toNum);
    calculerTableauReinscriptions(reinscriptions, toNum);
  };

  const calculerTableauInscrits = (inscrits, toNum) => {
    const stats = {
      global: { total: 0, fi: 0, ta: 0, executive: 0, ca: 0 },
      fi: { total: 0, masi: 0, irm: 0, cycleIngenieur: 0, genieCivil: 0, mecatronique: 0, master: 0, autre: 0, ca: 0 },
      executive: { total: 0, masi: 0, irm: 0, autre: 0, licencePro: 0, masterPro: 0, ca: 0 },
      ta: { total: 0, masi: 0, irm: 0, cycleIngenieur: 0, genieCivil: 0, mecatronique: 0, master: 0, autre: 0, ca: 0 }
    };

    inscrits.forEach((etudiant) => {
      const type = determinerTypeFormation(etudiant);
      const ca = toNum(etudiant.prixTotal);
      const typeFormation = etudiant.typeFormation || etudiant.filiere;

      stats.global.total += 1;
      stats.global.ca += ca;

      if (type === 'FI' || type === 'CYCLE_INGENIEUR') {
        stats.global.fi += 1;
        stats.fi.total += 1;
        stats.fi.ca += ca;

        if (typeFormation === 'MASI') {
          stats.fi.masi += 1;
        } else if (typeFormation === 'IRM') {
          stats.fi.irm += 1;
        } else if (typeFormation === 'CYCLE_INGENIEUR') {
          stats.fi.cycleIngenieur += 1;
        } else if (typeFormation === 'GENIE_CIVIL') {
          stats.fi.genieCivil += 1;
        } else if (typeFormation === 'MECATRONIQUE') {
          stats.fi.mecatronique += 1;
        } else if (typeFormation === 'MASTER') {
          stats.fi.master += 1;
        } else {
          stats.fi.autre += 1;
        }

      } else if (type === 'Executive') {
        stats.global.executive += 1;
        stats.executive.total += 1;
        stats.executive.ca += ca;

        if (typeFormation === 'MASI') {
          stats.executive.masi += 1;
        } else if (typeFormation === 'IRM') {
          stats.executive.irm += 1;
        } else if (typeFormation === 'LICENCE_PRO') {
          stats.executive.licencePro += 1;
        } else if (typeFormation === 'MASTER_PRO') {
          stats.executive.masterPro += 1;
        } else {
          stats.executive.autre += 1;
        }

      } else if (type === 'TA') {
        stats.global.ta += 1;
        stats.ta.total += 1;
        stats.ta.ca += ca;

        if (typeFormation === 'MASI') {
          stats.ta.masi += 1;
        } else if (typeFormation === 'IRM') {
          stats.ta.irm += 1;
        } else if (typeFormation === 'CYCLE_INGENIEUR') {
          stats.ta.cycleIngenieur += 1;
        } else if (typeFormation === 'GENIE_CIVIL') {
          stats.ta.genieCivil += 1;
        } else if (typeFormation === 'MECATRONIQUE') {
          stats.ta.mecatronique += 1;
        } else if (typeFormation === 'MASTER') {
          stats.ta.master += 1;
        } else {
          stats.ta.autre += 1;
        }
      }
    });

    setTableauInscrits(stats);
  };

  const calculerTableauReinscriptions = (reinscriptions, toNum) => {
    const stats = {
      global: { total: 0, fi: 0, ta: 0, executive: 0, ca: 0 },
      fi: { total: 0, masi: 0, irm: 0, cycleIngenieur: 0, genieCivil: 0, mecatronique: 0, master: 0, autre: 0, ca: 0 },
      executive: { total: 0, masi: 0, irm: 0, autre: 0, licencePro: 0, masterPro: 0, ca: 0 },
      ta: { total: 0, masi: 0, irm: 0, cycleIngenieur: 0, genieCivil: 0, mecatronique: 0, master: 0, autre: 0, ca: 0 }
    };

    reinscriptions.filter(etudiant => etudiant.nouvelleInscription === false && toNum(etudiant.prixTotal) > 0)
      .forEach((etudiant) => {
        const type = determinerTypeFormation(etudiant);
        const ca = toNum(etudiant.prixTotal);
        const typeFormation = etudiant.typeFormation || etudiant.filiere;

        stats.global.total += 1;
        stats.global.ca += ca;

        if (type === 'FI' || type === 'CYCLE_INGENIEUR') {
          stats.global.fi += 1;
          stats.fi.total += 1;
          stats.fi.ca += ca;

          if (typeFormation === 'MASI') {
            stats.fi.masi += 1;
          } else if (typeFormation === 'IRM') {
            stats.fi.irm += 1;
          } else if (typeFormation === 'CYCLE_INGENIEUR') {
            stats.fi.cycleIngenieur += 1;
          } else if (typeFormation === 'GENIE_CIVIL') {
            stats.fi.genieCivil += 1;
          } else if (typeFormation === 'MECATRONIQUE') {
            stats.fi.mecatronique += 1;
          } else if (typeFormation === 'MASTER') {
            stats.fi.master += 1;
          } else {
            stats.fi.autre += 1;
          }

        } else if (type === 'Executive') {
          stats.global.executive += 1;
          stats.executive.total += 1;
          stats.executive.ca += ca;

          if (typeFormation === 'MASI') {
            stats.executive.masi += 1;
          } else if (typeFormation === 'IRM') {
            stats.executive.irm += 1;
          } else if (typeFormation === 'LICENCE_PRO') {
            stats.executive.licencePro += 1;
          } else if (typeFormation === 'MASTER_PRO') {
            stats.executive.masterPro += 1;
          } else {
            stats.executive.autre += 1;
          }

        } else if (type === 'TA') {
          stats.global.ta += 1;
          stats.ta.total += 1;
          stats.ta.ca += ca;

          if (typeFormation === 'MASI') {
            stats.ta.masi += 1;
          } else if (typeFormation === 'IRM') {
            stats.ta.irm += 1;
          } else if (typeFormation === 'CYCLE_INGENIEUR') {
            stats.ta.cycleIngenieur += 1;
          } else if (typeFormation === 'GENIE_CIVIL') {
            stats.ta.genieCivil += 1;
          } else if (typeFormation === 'MECATRONIQUE') {
            stats.ta.mecatronique += 1;
          } else if (typeFormation === 'MASTER') {
            stats.ta.master += 1;
          } else {
            stats.ta.autre += 1;
          }
        }
      });

    setTableauReinscriptions(stats);
  };

  const calculerDesistementsDirectement = (etudiantsData, anneeFilter) => {
    const etudiantsFiltres = anneeFilter === 'toutes'
      ? etudiantsData
      : etudiantsData.filter(e => e.anneeScolaire === anneeFilter);

    const etudiantsDesistes = etudiantsFiltres.filter(e => e.desistement?.statut === true);

    const stats = {
      total: etudiantsDesistes.length,
      parRaison: {},
      parType: { fi: 0, ta: 0, executive: 0 },
      parFiliere: {},
      evolution: []
    };

    etudiantsDesistes.forEach(etudiant => {
      const raison = etudiant.desistement.raison || 'Non spécifiée';
      stats.parRaison[raison] = (stats.parRaison[raison] || 0) + 1;

      const type = determinerTypeFormation(etudiant);
      if (type === 'FI' || type === 'CYCLE_INGENIEUR') {
        stats.parType.fi += 1;
      } else if (type === 'Executive') {
        stats.parType.executive += 1;
      } else if (type === 'TA') {
        stats.parType.ta += 1;
      }

      const filiere = etudiant.filiere || 'Non définie';
      stats.parFiliere[filiere] = (stats.parFiliere[filiere] || 0) + 1;
    });

    if (anneeFilter !== 'toutes' && etudiantsDesistes.length > 0) {
      const parMois = {};
      etudiantsDesistes.forEach(etudiant => {
        if (etudiant.desistement.dateDesistement) {
          const date = new Date(etudiant.desistement.dateDesistement);
          const mois = date.toLocaleDateString('fr-FR', { year: 'numeric', month: 'short' });
          parMois[mois] = (parMois[mois] || 0) + 1;
        }
      });
      stats.evolution = Object.entries(parMois).map(([mois, count]) => ({ mois, count }));
    }

    setDesistements(stats);
  };

  const calculerPreinscriptionsDirectement = (etudiantsData, commerciauxData, anneeFilter) => {
    if (anneeFilter === '2024/2025') {
      setPreinscriptions({
        count: 0,
        parType: { fi: 0, ta: 0, executive: 0 },
        parFiliere: {},
        parCommercial: {}
      });
      return;
    }

    if (anneeFilter === '2025/2026') {
      setPreinscriptions(donneesFixes2025_2026.preinscriptionsStats);
      return;
    }

    const etudiantsFiltres = anneeFilter === 'toutes'
      ? etudiantsData.filter(e => e.isPartner !== true)
      : etudiantsData.filter(e => e.anneeScolaire === anneeFilter && e.isPartner !== true);

    const preinscrits = etudiantsFiltres.filter(e => {
      const prix = parseFloat(e.prixTotal) || 0;
      return prix === 0;
    });

    const stats = {
      count: preinscrits.length,
      parType: { fi: 0, ta: 0, executive: 0 },
      parFiliere: {},
      parCommercial: {}
    };

    preinscrits.forEach(etudiant => {
      const type = determinerTypeFormation(etudiant);
      if (type === 'FI' || type === 'CYCLE_INGENIEUR') {
        stats.parType.fi += 1;
      } else if (type === 'Executive') {
        stats.parType.executive += 1;
      } else if (type === 'TA') {
        stats.parType.ta += 1;
      }

      const filiere = etudiant.filiere || 'Non définie';
      stats.parFiliere[filiere] = (stats.parFiliere[filiere] || 0) + 1;

      const commercial = etudiant.commercial;
      if (commercial) {
        const commercialInfo = commerciauxData.find(c => c._id === commercial);
        const nomCommercial = commercialInfo ? commercialInfo.nom : 'Commercial inconnu';
        const nomLower = nomCommercial.toLowerCase();
        if (!nomLower.includes('serti') && !nomLower.includes('najat')) {
          stats.parCommercial[nomCommercial] = (stats.parCommercial[nomCommercial] || 0) + 1;
        }
      }
    });

    setPreinscriptions(stats);
  };

  const calculerPreinscriptions = (etudiantsData, anneeFilter) => {
    if (anneeFilter === '2024/2025') {
      setPreinscriptions({
        count: 0,
        parType: { fi: 0, ta: 0, executive: 0 },
        parFiliere: {},
        parCommercial: {}
      });
      return;
    }

    if (anneeFilter === '2025/2026') {
      setPreinscriptions(donneesFixes2025_2026.preinscriptionsStats);
      return;
    }

    const etudiantsFiltres = anneeFilter === 'toutes'
      ? etudiantsData.filter(e => e.isPartner !== true)
      : etudiantsData.filter(e => e.anneeScolaire === anneeFilter && e.isPartner !== true);

    const preinscrits = etudiantsFiltres.filter(e => {
      const prix = parseFloat(e.prixTotal) || 0;
      return prix === 0;
    });

    const stats = {
      count: preinscrits.length,
      parType: { fi: 0, ta: 0, executive: 0 },
      parFiliere: {},
      parCommercial: {}
    };

    preinscrits.forEach(etudiant => {
      const type = determinerTypeFormation(etudiant);
      if (type === 'FI' || type === 'CYCLE_INGENIEUR') {
        stats.parType.fi += 1;
      } else if (type === 'Executive') {
        stats.parType.executive += 1;
      } else if (type === 'TA') {
        stats.parType.ta += 1;
      }

      const filiere = etudiant.filiere || 'Non définie';
      stats.parFiliere[filiere] = (stats.parFiliere[filiere] || 0) + 1;

      const commercial = etudiant.commercial;
      if (commercial) {
        const commercialInfo = commerciaux.find(c => c._id === commercial);
        const nomCommercial = commercialInfo ? commercialInfo.nom : 'Commercial inconnu';
        stats.parCommercial[nomCommercial] = (stats.parCommercial[nomCommercial] || 0) + 1;
      }
    });

    setPreinscriptions(stats);
  };

  const determinerTypeFormation = (etudiant) => {
    const tf = etudiant.typeFormation || etudiant.filiere;

    if (tf) {
      if (tf === 'LICENCE_PRO') return 'Executive';
      if (tf === 'MASTER_PRO') return 'Executive';

      if (tf === 'CYCLE_INGENIEUR') {
        const niveau = (etudiant.niveauFormation || '').toLowerCase();
        const cycle = (etudiant.cycle || '').toLowerCase();

        if (niveau.includes('executive') || cycle.includes('executive')) return 'Executive';

        if (niveau.includes('ta') || niveau.includes('altern') || cycle.includes('ta') || cycle.includes('altern') || niveau === 'ta') {
          return 'TA';
        }

        return 'FI';
      }

      if (tf === 'MASI' || tf === 'IRM') {
        const niveau = (etudiant.niveauFormation || '').toLowerCase();
        if (niveau.includes('executive')) return 'Executive';
        if (niveau.includes('ta') || niveau.includes('altern') || niveau === 'ta') return 'TA';
        return 'FI';
      }

      if (tf === 'Executive' || tf === 'TA' || tf === 'FI') return tf;
    }

    const niveau = (etudiant.niveauFormation || '').toLowerCase();
    const cycle = (etudiant.cycle || '').toLowerCase();

    if (niveau.includes('executive') || cycle.includes('executive')) return 'Executive';
    if (niveau.includes('ta') || niveau.includes('altern') || cycle.includes('ta') || cycle.includes('altern') || niveau === 'ta') {
      return 'TA';
    }

    return 'FI';
  };

  const determinerFiliereClassification = (etudiant) => {
    const tf = etudiant.typeFormation;

    if (tf === 'LICENCE_PRO') {
      const specialite = etudiant.specialiteLicencePro || '';

      const specialitesIRM = [
        'Tests Logiciels avec Tests Automatisés',
        'Développement Informatique Full Stack',
        'Administration des Systèmes, Bases de Données, Cybersécurité et Cloud Computing',
        'Réseaux et Cybersécurité',
        'Electrotechnique et systèmes – Cnam',
        'Informatique – Cnam'
      ];

      const specialitesIMASI = [
        'Marketing digital e-business Casablanca',
        'Gestion de la Qualité',
        'Finance, Audit & Entrepreneuriat',
        'Développement Commercial et Marketing Digital',
        'Management et Conduite de Travaux – Cnam',
        'Achat & Logistique'
      ];

      if (specialitesIRM.includes(specialite)) return 'irm';
      if (specialitesIMASI.includes(specialite)) return 'masi';
      return 'autre';
    }

    if (tf === 'MASTER_PRO') {
      const specialite = etudiant.specialiteMasterPro || '';

      const specialitesIRM = [
        'Informatique, Data Sciences, Cloud, Cybersécurité & Intelligence Artificielle (DU IDCIA)',
        'Management des Systèmes d\'Information',
        'Big Data et Intelligence Artificielle',
        'Réseaux et Cybersécurité',
        'Génie Informatique et Innovation Technologique'
      ];

      const specialitesIMASI = [
        'QHSSE & Performance Durable',
        'Achat, Logistique et Supply Chain Management',
        'Finance, Audit & Entrepreneuriat',
        'Développement Commercial et Marketing Digital'
      ];

      if (specialitesIRM.includes(specialite)) return 'irm';
      if (specialitesIMASI.includes(specialite)) return 'masi';
      return 'autre';
    }

    if (tf === 'CYCLE_INGENIEUR') {
      const specialite = etudiant.specialiteIngenieur || '';

      if (specialite === 'Génie Informatique') return 'irm';
      if (specialite === 'Génie Mécatronique' || specialite === 'Génie Civil') return 'autre';
      return 'autre';
    }

    if (tf === 'MASI') return 'masi';
    if (tf === 'IRM') return 'irm';

    const filiere = (etudiant.filiere || '').toLowerCase();
    const specialite = (etudiant.specialite || '').toLowerCase();

    if (filiere.includes('masi') || specialite.includes('masi')) return 'masi';
    if (filiere.includes('irm') || specialite.includes('irm')) return 'irm';

    return 'autre';
  };

  const formatMoney = (amount) =>
    new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/';
  };

  const fetchPartnerChiffres = async (annee = '2026/2027') => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`     https://vmi1977988.contaboserver.net/api2/partnerChiffresAffaires?anneeScolaire=${annee}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) setPartnerChiffres(data.data);
    } catch (err) {
      console.error('Erreur fetch partenaires:', err);
    }
  };

  const createPartnerChiffre = async (partnerData) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('    https://vmi1977988.contaboserver.net/api2/partnerChiffresAffaires', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(partnerData)
      });
      const data = await response.json();
      if (data.success) {
        setPartnerChiffres([...partnerChiffres, data.data]);
        alert('Partenaire créé');
      }
    } catch (err) {
      console.error('Erreur création:', err);
      alert('Erreur création partenaire');
    }
  };

  const updatePartnerChiffre = async (id, updateData) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`     https://vmi1977988.contaboserver.net/api2/partnerChiffresAffaires/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(updateData)
      });
      const data = await response.json();
      if (data.success) {
        setPartnerChiffres(partnerChiffres.map(p => p._id === id ? data.data : p));
        setEditingPartnerId(null);
        alert('Partenaire modifié');
      }
    } catch (err) {
      console.error('Erreur mise à jour:', err);
      alert('Erreur mise à jour partenaire');
    }
  };

  const deletePartnerChiffre = async (id) => {
    if (!window.confirm('Supprimer ce partenaire ?')) return;
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`     https://vmi1977988.contaboserver.net/api2/partnerChiffresAffaires/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        setPartnerChiffres(partnerChiffres.filter(p => p._id !== id));
        alert('Partenaire supprimé');
      }
    } catch (err) {
      console.error('Erreur suppression:', err);
      alert('Erreur suppression partenaire');
    }
  };

  const calculatePartnerTotals = () => {
    const list = getUnifiedPartnersList();
    const totalStudents = list.reduce((sum, p) => sum + (p.realisedStudents || 0), 0);
    const totalRevenue = list.reduce((sum, p) => sum + (p.realisedCA || 0), 0);
    return {
      totalStudents,
      totalRevenue,
      totalRealisation: totalRevenue,
      totalPartnersCount: list.length
    };
  };

  const handleAnneeChange = (nouvelleAnnee) => {
    setAnneeScolaireFilter(nouvelleAnnee);
    if (etudiants.length > 0) {
      calculerStatistiquesAvecAnnee(etudiants, nouvelleAnnee, partners);
      calculerStatistiquesCommerciauxDirectement(etudiants, commerciaux, nouvelleAnnee);
      calculerPreinscriptionsDirectement(etudiants, commerciaux, nouvelleAnnee);
      calculerStatistiquesPartnersDirectement(etudiants, partners, nouvelleAnnee);
      calculerDesistementsDirectement(etudiants, nouvelleAnnee);
    }
    fetchPartnerChiffres(nouvelleAnnee);
    fetchChiffreAffaireMissions(nouvelleAnnee); // ✅ APPEL CORRECT
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getUnifiedPartnersList = () => {
    const allNames = new Set();
    partnerChiffres.forEach(p => { if (p.name) allNames.add(p.name); });
    statsPartners.forEach(p => { if (p.nomPartner) allNames.add(p.nomPartner); });

    const list = Array.from(allNames)
      .filter(name => {
        const nameLower = name.toLowerCase();
        return !nameLower.includes('serti') && !nameLower.includes('najat') && nameLower.trim() !== 'partner inconnu';
      })
      .map(name => {
        const manual = partnerChiffres.find(p => p.name?.toLowerCase().trim() === name.toLowerCase().trim());
        const auto = statsPartners.find(p => p.nomPartner?.toLowerCase().trim() === name.toLowerCase().trim());

        const targetStudents = manual ? (manual.students || 0) : 0;
        const targetCA = manual ? (manual.revenue || 0) : 0;

        const realisedStudents = (manual && manual.realisedStudents !== undefined)
          ? manual.realisedStudents
          : (auto ? (auto.countEtudiants || 0) : 0);

        const realisedCA = (manual && manual.realisation !== undefined)
          ? manual.realisation
          : (auto ? (auto.chiffreAffaire || 0) : 0);

        const ecartStudents = (manual && manual.ecartStudents !== undefined)
          ? manual.ecartStudents
          : (realisedStudents - targetStudents);

        const ecartCA = (manual && manual.ecartCA !== undefined)
          ? manual.ecartCA
          : (realisedCA - targetCA);

        return {
          name,
          _id: manual ? manual._id : `auto-${name}`,
          isManualOnly: !auto && !!manual,
          isAutoOnly: !manual && !!auto,
          isBoth: !!manual && !!auto,
          manualEntry: manual || null,
          autoEntry: auto || null,
          targetStudents,
          targetCA,
          realisedStudents,
          realisedCA,
          ecartStudents,
          ecartCA,
          paymentSchedule: manual ? manual.paymentSchedule : 'Automatique'
        };
      });

    return list.sort((a, b) => b.realisedCA - a.realisedCA);
  };

  const partnerTotals = calculatePartnerTotals();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f8fafc' }}>
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              width: '48px',
              height: '48px',
              border: '4px solid #e2e8f0',
              borderTop: '4px solid #2563eb',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 1rem'
            }}
          ></div>
          <p style={{ color: '#64748b', fontSize: '1.1rem' }}>Chargement des données...</p>
        </div>
      </div>
    );
  }

  const filieresData = analyseFilieres();

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <Sidebar onLogout={handleLogout} />

      <div style={{ flex: 1, paddingLeft: '0' }}>
        {/* Filtre par année scolaire */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            padding: '1rem',
            background: '#f9fafb',
            borderRadius: '6px',
            border: '1px solid #e5e7eb',
            marginTop: '2rem'
          }}
        >
          <Filter size={18} />
          <span style={{ fontWeight: '600', color: '#374151', fontSize: '0.9rem' }}>Année scolaire:</span>
          <select
            value={anneeScolaireFilter}
            onChange={(e) => handleAnneeChange(e.target.value)}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              border: '1px solid #d1d5db',
              backgroundColor: 'white',
              fontSize: '0.9rem',
              cursor: 'pointer'
            }}
          >
            <option value="toutes">Toutes les années</option>
            <option value="2026/2027">2026/2027</option>
            <option value="2025/2026">2025/2026</option>
            <option value="2024/2025">2024/2025</option>
            {anneesDisponibles
              .filter((a) => a !== '2024/2025' && a !== '2025/2026' && a !== '2026/2027')
              .map((annee) => (
                <option key={annee} value={annee}>
                  {annee}
                </option>
              ))}
          </select>
        </div>
        <div style={{ padding: '2rem' }}>
          {/* Header */}
          <div
            style={{
              background: '#fff',
              borderRadius: '8px',
              padding: '2rem',
              marginBottom: '2rem',
              border: '1px solid #e5e7eb'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
              <div>
                <h1
                  style={{
                    fontSize: '1.75rem',
                    fontWeight: 'bold',
                    color: '#1f2937',
                    margin: '0 0 0.5rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                  }}
                >
                  <Home size={28} />
                  Chiffre d'Affaire {anneeScolaireFilter}
                </h1>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <AutoMissionModal />

                <button
                  onClick={fetchData}
                  style={{
                    background: '#374151',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '0.75rem 1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  <RotateCcw size={16} />
                  Actualiser
                </button>
              </div>
            </div>

            {/* Chiffre d'Affaire avec Missions */}
            <div
              style={{
                background: '#fff',
                borderRadius: '8px',
                padding: '2rem',
                marginBottom: '2rem',
                border: '1px solid #e5e7eb'
              }}
            >
              <h2
                style={{
                  fontSize: '1.25rem',
                  fontWeight: 'bold',
                  color: '#1f2937',
                  marginBottom: '2rem',
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}
              >
                Chiffre d'Affaires {anneeScolaireFilter === 'toutes' ? '' : anneeScolaireFilter}
              </h2>

              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e5e7eb' }}>
                    <th style={{ padding: '1rem', textAlign: 'center', fontWeight: '600', color: '#374151', fontSize: '0.9rem' }}>
                      Total Inscrit
                    </th>
                    <th style={{ padding: '1rem', textAlign: 'center', fontWeight: '600', color: '#374151', fontSize: '0.9rem' }}>
                      Chiffre d'affaire
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* Nouveaux Inscrits */}
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                      <strong>Nouveaux Inscrits</strong>
                      <br />
                      <span style={{ fontSize: '1.25rem', color: '#1f2937', fontWeight: 'bold' }}>{chiffreAffaire.nouveauxInscrits.count}</span>
                    </td>
                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                      <strong>{formatMoney(chiffreAffaire.nouveauxInscrits.ca)} MAD</strong>
                    </td>
                  </tr>

                  {/* Détail Maroc / Afrique */}
                  {chiffreAffaire.nouveauxInscrits.maroc && (
                    <>
                      <tr style={{ borderBottom: '1px solid #f3f4f6', backgroundColor: '#f9fafb' }}>
                        <td style={{ padding: '0.5rem 1rem', textAlign: 'center', fontSize: '0.85rem', color: '#6b7280' }}>
                          <em> Maroc</em>
                          <br />
                          <strong>{chiffreAffaire.nouveauxInscrits.maroc.count}</strong>
                        </td>
                        <td style={{ padding: '0.5rem 1rem', textAlign: 'center', fontSize: '0.85rem', color: '#374151', fontWeight: 'bold' }}>
                          <strong>{formatMoney(chiffreAffaire.nouveauxInscrits.maroc.ca)} MAD</strong>
                        </td>
                      </tr>
                      <tr style={{ borderBottom: '1px solid #f3f4f6', backgroundColor: '#f9fafb' }}>
                        <td style={{ padding: '0.5rem 1rem', textAlign: 'center', fontSize: '0.85rem', color: '#6b7280' }}>
                          <em>Afrique</em>
                          <br />
                          <strong>{chiffreAffaire.nouveauxInscrits.afrique.count}</strong>
                        </td>
                        <td style={{ padding: '0.5rem 1rem', textAlign: 'center', fontSize: '0.85rem', color: '#374151', fontWeight: 'bold' }}>
                          <strong>{formatMoney(chiffreAffaire.nouveauxInscrits.afrique.ca)} MAD</strong>
                        </td>
                      </tr>
                    </>
                  )}

                  {/* Réinscriptions */}
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                      <strong>Réinscriptions</strong>
                      <br />
                      <span style={{ fontSize: '1.25rem', color: '#1f2937', fontWeight: 'bold' }}>{chiffreAffaire.reinscriptions.count}</span>
                    </td>
                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                      <strong>{formatMoney(chiffreAffaire.reinscriptions.ca)} MAD</strong>
                    </td>
                  </tr>



                  {/* SOUS-TOTAL - Nouveaux Inscrits + Réinscriptions + Transférés */}
                  <tr style={{ borderBottom: '2px solid #e5e7eb', backgroundColor: '#fef3c7' }}>
                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                      <strong>Sous-total Étudiants</strong>
                      <br />
                      <span style={{ fontSize: '1.25rem', color: '#1f2937', fontWeight: 'bold' }}>
                        {chiffreAffaire.nouveauxInscrits.count + chiffreAffaire.reinscriptions.count + chiffreAffaire.transferes.count}
                      </span>
                    </td>
                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                      <strong style={{ fontSize: '1.05rem' }}>
                        {formatMoney(chiffreAffaire.nouveauxInscrits.ca + chiffreAffaire.reinscriptions.ca + chiffreAffaire.transferes.ca)} MAD
                      </strong>
                    </td>
                  </tr>

                  {/* Partners */}
                  {partnerTotals.totalStudents > 0 && (
                    <tr style={{ borderBottom: '1px solid #f3f4f6', backgroundColor: '#f9fafb' }}>
                      <td style={{ padding: '1rem', textAlign: 'center' }}>
                        <strong>Total Partners</strong>
                        <br />
                        <span style={{ fontSize: '1rem', color: '#64748b' }}>
                          <strong>{partnerTotals.totalStudents}</strong> étudiants (<strong>{partnerChiffres.length}</strong> partenaires)
                        </span>
                      </td>
                      <td style={{ padding: '1rem', textAlign: 'center' }}>
                        <strong style={{ fontSize: '1.1rem' }}>
                          {formatMoney(partnerTotals.totalRevenue)} MAD
                        </strong>
                      </td>
                    </tr>
                  )}

                  {/* ✅ NOUVELLE LIGNE - Missions */}
                  {chiffreAffaireMissions > 0 && (
                    <tr style={{ borderBottom: '2px solid #e5e7eb', backgroundColor: '#fef2f2' }}>
                      <td style={{ padding: '1rem', textAlign: 'center' }}>
                        <strong style={{ color: '#dc2626' }}>Frais de Missions</strong>
                        <br />
                        <span style={{ fontSize: '0.875rem', color: '#dc2626' }}>
                          (Déplacements professionnels)
                        </span>
                      </td>
                      <td style={{ padding: '1rem', textAlign: 'center' }}>
                        <strong style={{ fontSize: '1.1rem', color: '#dc2626' }}>
                          - {formatMoney(chiffreAffaireMissions)} MAD
                        </strong>
                      </td>
                    </tr>
                  )}

                  {/* TOTAL GLOBAL */}
                  <tr style={{ borderBottom: '2px solid #e5e7eb', backgroundColor: '#f0f9ff' }}>
                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                      <strong style={{ fontSize: '1.1rem' }}>TOTAL GÉNÉRAL</strong>
                      <br />
                      <span style={{ fontSize: '1.5rem', color: '#1f2937', fontWeight: 'bold' }}>
                        {chiffreAffaire.nouveauxInscrits.count + chiffreAffaire.reinscriptions.count + chiffreAffaire.transferes.count + partnerTotals.totalStudents}
                        {chiffreAffaireMissions > 0 && (
                          <span style={{ fontSize: '0.875rem', color: '#6b7280', fontWeight: 'normal', display: 'block' }}>
                            étudiants inscrits
                          </span>
                        )}
                      </span>
                    </td>
                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                      <strong style={{ fontSize: '1.25rem', color: '#1e40af' }}>
                        {formatMoney(
                          chiffreAffaire.nouveauxInscrits.ca +
                          chiffreAffaire.reinscriptions.ca +
                          chiffreAffaire.transferes.ca +
                          partnerTotals.totalRevenue -
                          chiffreAffaireMissions
                        )} MAD
                      </strong>
                      {chiffreAffaireMissions > 0 && (
                        <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.5rem' }}>
                          (Revenus: <strong>{formatMoney(chiffreAffaire.nouveauxInscrits.ca + chiffreAffaire.reinscriptions.ca + chiffreAffaire.transferes.ca + partnerTotals.totalRevenue)} MAD</strong>
                          - Missions: <strong>{formatMoney(chiffreAffaireMissions)} MAD</strong>)
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>


            </div>
          </div>

          {/* Section Préinscriptions */}
          {anneeScolaireFilter !== '2024/2025' && preinscriptions.count > 0 && (
            <div
              style={{
                background: '#fff',
                borderRadius: '8px',
                padding: '2rem',
                marginBottom: '2rem',
                border: '1px solid #e5e7eb'
              }}
            >
              <h2
                style={{
                  fontSize: '1.25rem',
                  fontWeight: 'bold',
                  color: '#1f2937',
                  marginBottom: '2rem',
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}
              >
                <Clock size={24} />
                Préinscriptions  - {anneeScolaireFilter}
              </h2>

              <div style={{
                background: '#fef3c7',
                borderRadius: '8px',
                padding: '1.5rem',
                marginBottom: '2rem',
                border: '1px solid #f59e0b',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#92400e' }}>
                  {preinscriptions.count}
                </div>
                <div style={{ color: '#92400e', fontWeight: '600' }}>
                  Étudiants en préinscription
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '2rem' }}>
                <div style={{ background: '#f0f9ff', padding: '1rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #0ea5e9' }}>
                  <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#0c4a6e' }}>
                    {preinscriptions.parType.fi}
                  </div>
                  <div style={{ color: '#0c4a6e', fontSize: '0.9rem' }}>FI</div>
                </div>
                <div style={{ background: '#f0fdf4', padding: '1rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #22c55e' }}>
                  <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#14532d' }}>
                    {preinscriptions.parType.ta}
                  </div>
                  <div style={{ color: '#14532d', fontSize: '0.9rem' }}>TA</div>
                </div>
                <div style={{ background: '#fdf4ff', padding: '1rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #a855f7' }}>
                  <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#581c87' }}>
                    {preinscriptions.parType.executive}
                  </div>
                  <div style={{ color: '#581c87', fontSize: '0.9rem' }}>Executive</div>
                </div>
              </div>

              {/* Répartition par filière */}
              {Object.keys(preinscriptions.parFiliere).length > 0 && (
                <div style={{ marginBottom: '2rem' }}>
                  <h3 style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#374151' }}>
                    Répartition par filière
                  </h3>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                    {Object.entries(preinscriptions.parFiliere).map(([filiere, count]) => (
                      <div key={filiere} style={{
                        background: '#f8fafc',
                        padding: '1rem',
                        borderRadius: '6px',
                        border: '1px solid #e2e8f0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <span style={{ fontSize: '0.9rem', color: '#475569' }}>{filiere}</span>
                        <span style={{
                          background: '#3b82f6',
                          color: 'white',
                          padding: '0.25rem 0.75rem',
                          borderRadius: '999px',
                          fontSize: '0.8rem',
                          fontWeight: '600'
                        }}>
                          {count}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Répartition par commercial */}
              {Object.keys(preinscriptions.parCommercial).length > 0 && (
                <div>
                  <h3 style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#374151' }}>
                    Répartition par commercial
                  </h3>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
                    {Object.entries(preinscriptions.parCommercial).map(([commercial, count]) => (
                      <div key={commercial} style={{
                        background: '#f8fafc',
                        padding: '1rem',
                        borderRadius: '6px',
                        border: '1px solid #e2e8f0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <span style={{ fontSize: '0.9rem', color: '#475569' }}>{commercial}</span>
                        <span style={{
                          background: '#10b981',
                          color: 'white',
                          padding: '0.25rem 0.75rem',
                          borderRadius: '999px',
                          fontSize: '0.8rem',
                          fontWeight: '600'
                        }}>
                          {count}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Tableau des Inscrits */}
          <div
            style={{
              background: '#fff',
              borderRadius: '8px',
              padding: '2rem',
              marginBottom: '2rem',
              border: '1px solid #e5e7eb'
            }}
          >
            <h2
              style={{
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#1f2937',
                marginBottom: '2rem',
                textAlign: 'center'
              }}
            >
              Tableau des Inscrits {anneeScolaireFilter === 'toutes' ? '' : anneeScolaireFilter}
            </h2>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1rem' }}>
              {/* Global */}
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
                <h3 style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#374151' }}>Global</h3>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                  Total d'inscrits <strong>{tableauInscrits.global.total}</strong>
                </div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>FI <strong>{tableauInscrits.global.fi}</strong></div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>TA <strong>{tableauInscrits.global.ta}</strong></div>
                <div style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>
                  Executive <strong>{tableauInscrits.global.executive}</strong>
                </div>
                <div style={{ fontWeight: 'bold', color: '#1f2937', fontSize: '0.95rem' }}>
                  {formatMoney(tableauInscrits.global.ca)} MAD
                </div>
              </div>

              {/* FI */}
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
                <h3 style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#374151' }}>FI</h3>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                  Total <strong>{tableauInscrits.fi.total}</strong>
                </div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>MASI <strong>{tableauInscrits.fi.masi}</strong></div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>IRM <strong>{tableauInscrits.fi.irm}</strong></div>
                {anneeScolaireFilter !== '2024/2025' && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Cycle Ing. <strong>{tableauInscrits.fi.cycleIngenieur}</strong></div>
                )}
                {tableauInscrits.fi.genieCivil > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Génie Civil <strong>{tableauInscrits.fi.genieCivil}</strong></div>
                )}
                {tableauInscrits.fi.mecatronique > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Mécatronique <strong>{tableauInscrits.fi.mecatronique}</strong></div>
                )}
                {tableauInscrits.fi.master > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Master <strong>{tableauInscrits.fi.master}</strong></div>
                )}
                {tableauInscrits.fi.autre > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Autre <strong>{tableauInscrits.fi.autre}</strong></div>
                )}
                <div style={{ fontWeight: 'bold', color: '#1f2937', fontSize: '0.95rem' }}>
                  {formatMoney(tableauInscrits.fi.ca)} MAD
                </div>
              </div>

              {/* Executive */}
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
                <h3 style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#374151' }}>Exécutive</h3>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Total <strong>{tableauInscrits.executive.total}</strong></div>

                {anneeScolaireFilter === '2024/2025' ? (
                  <>
                    <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>MASI <strong>{tableauInscrits.executive.masi}</strong></div>
                    <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>IRM <strong>{tableauInscrits.executive.irm}</strong></div>
                    <div style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>Autre <strong>{tableauInscrits.executive.autre}</strong></div>
                  </>
                ) : (
                  <>
                    {anneeScolaireFilter !== '2024/2025' && tableauInscrits.executive.masi > 0 && (
                      <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>MASI <strong>{tableauInscrits.executive.masi}</strong></div>
                    )}
                    {anneeScolaireFilter !== '2024/2025' && tableauInscrits.executive.irm > 0 && (
                      <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>IRM <strong>{tableauInscrits.executive.irm}</strong></div>
                    )}
                    <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Licence Pro <strong>{tableauInscrits.executive.licencePro}</strong></div>
                    <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Master Pro <strong>{tableauInscrits.executive.masterPro}</strong></div>
                    {anneeScolaireFilter !== '2024/2025' && tableauInscrits.executive.autre > 0 && (
                      <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Autre <strong>{tableauInscrits.executive.autre}</strong></div>
                    )}
                  </>
                )}

                <div style={{ fontWeight: 'bold', color: '#1f2937', fontSize: '0.95rem' }}>
                  {formatMoney(tableauInscrits.executive.ca)} MAD
                </div>
              </div>

              {/* TA */}
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
                <h3 style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#374151' }}>TA</h3>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Total <strong>{tableauInscrits.ta.total}</strong></div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>MASI <strong>{tableauInscrits.ta.masi}</strong></div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>IRM <strong>{tableauInscrits.ta.irm}</strong></div>
                {anneeScolaireFilter !== '2024/2025' && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Cycle Ing. <strong>{tableauInscrits.ta.cycleIngenieur}</strong></div>
                )}
                {tableauInscrits.ta.genieCivil > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Génie Civil <strong>{tableauInscrits.ta.genieCivil}</strong></div>
                )}
                {tableauInscrits.ta.mecatronique > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Mécatronique <strong>{tableauInscrits.ta.mecatronique}</strong></div>
                )}
                {tableauInscrits.ta.master > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Master <strong>{tableauInscrits.ta.master}</strong></div>
                )}
                {tableauInscrits.ta.autre > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Autre <strong>{tableauInscrits.ta.autre}</strong></div>
                )}
                <div style={{ fontWeight: 'bold', color: '#1f2937', fontSize: '0.95rem' }}>
                  {formatMoney(tableauInscrits.ta.ca)} MAD
                </div>
              </div>
            </div>
          </div>

          {/* Tableau des réinscriptions */}
          <div
            style={{
              background: '#fff',
              borderRadius: '8px',
              padding: '2rem',
              marginBottom: '2rem',
              border: '1px solid #e5e7eb'
            }}
          >
            <h2
              style={{
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#1f2937',
                marginBottom: '2rem',
                textAlign: 'center'
              }}
            >
              Tableau des réinscriptions {anneeScolaireFilter === 'toutes' ? '' : anneeScolaireFilter}
            </h2>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1rem' }}>
              {/* Global */}
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
                <h3 style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#374151' }}>Global</h3>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                  Total de réinscriptions <strong>{tableauReinscriptions.global.total}</strong>
                </div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>FI <strong>{tableauReinscriptions.global.fi}</strong></div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>TA <strong>{tableauReinscriptions.global.ta}</strong></div>
                <div style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>
                  Executive <strong>{tableauReinscriptions.global.executive}</strong>
                </div>
                <div style={{ fontWeight: 'bold', color: '#1f2937', fontSize: '0.95rem' }}>
                  {formatMoney(tableauReinscriptions.global.ca)} MAD
                </div>
              </div>

              {/* FI */}
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
                <h3 style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#374151' }}>FI</h3>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                  Total FI <strong>{tableauReinscriptions.fi.total}</strong>
                </div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>MASI <strong>{tableauReinscriptions.fi.masi}</strong></div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>IRM <strong>{tableauReinscriptions.fi.irm}</strong></div>
                {anneeScolaireFilter !== '2024/2025' && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Cycle Ing. <strong>{tableauReinscriptions.fi.cycleIngenieur}</strong></div>
                )}
                {tableauReinscriptions.fi.genieCivil > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Génie Civil <strong>{tableauReinscriptions.fi.genieCivil}</strong></div>
                )}
                {tableauReinscriptions.fi.mecatronique > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Mécatronique <strong>{tableauReinscriptions.fi.mecatronique}</strong></div>
                )}
                {tableauReinscriptions.fi.master > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Master <strong>{tableauReinscriptions.fi.master}</strong></div>
                )}
                {tableauReinscriptions.fi.autre > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Autre <strong>{tableauReinscriptions.fi.autre}</strong></div>
                )}
                <div style={{ fontWeight: 'bold', color: '#1f2937', fontSize: '0.95rem' }}>
                  {formatMoney(tableauReinscriptions.fi.ca)} MAD
                </div>
              </div>

              {/* Executive */}
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
                <h3 style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#374151' }}>Exécutive</h3>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                  Total Executive <strong>{tableauReinscriptions.executive.total}</strong>
                </div>

                {anneeScolaireFilter === '2024/2025' ? (
                  <>
                    <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>MASI <strong>{tableauReinscriptions.executive.masi}</strong></div>
                    <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>IRM <strong>{tableauReinscriptions.executive.irm}</strong></div>
                    <div style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>Autre <strong>{tableauReinscriptions.executive.autre}</strong></div>
                  </>
                ) : (
                  <>
                    {anneeScolaireFilter !== '2024/2025' && tableauReinscriptions.executive.masi > 0 && (
                      <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>MASI <strong>{tableauReinscriptions.executive.masi}</strong></div>
                    )}
                    {anneeScolaireFilter !== '2024/2025' && tableauReinscriptions.executive.irm > 0 && (
                      <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>IRM <strong>{tableauReinscriptions.executive.irm}</strong></div>
                    )}
                    <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Licence Pro <strong>{tableauReinscriptions.executive.licencePro}</strong></div>
                    <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Master Pro <strong>{tableauReinscriptions.executive.masterPro}</strong></div>
                    {anneeScolaireFilter !== '2024/2025' && tableauReinscriptions.executive.autre > 0 && (
                      <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Autre <strong>{tableauReinscriptions.executive.autre}</strong></div>
                    )}
                  </>
                )}

                <div style={{ fontWeight: 'bold', color: '#1f2937', fontSize: '0.95rem' }}>
                  {formatMoney(tableauReinscriptions.executive.ca)} MAD
                </div>
              </div>

              {/* TA */}
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '6px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
                <h3 style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#374151' }}>TA</h3>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Total TA <strong>{tableauReinscriptions.ta.total}</strong></div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>MASI <strong>{tableauReinscriptions.ta.masi}</strong></div>
                <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>IRM <strong>{tableauReinscriptions.ta.irm}</strong></div>
                {anneeScolaireFilter !== '2024/2025' && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Cycle Ing. <strong>{tableauReinscriptions.ta.cycleIngenieur}</strong></div>
                )}
                {tableauReinscriptions.ta.genieCivil > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Génie Civil <strong>{tableauReinscriptions.ta.genieCivil}</strong></div>
                )}
                {tableauReinscriptions.ta.mecatronique > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Mécatronique <strong>{tableauReinscriptions.ta.mecatronique}</strong></div>
                )}
                {tableauReinscriptions.ta.master > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Master <strong>{tableauReinscriptions.ta.master}</strong></div>
                )}
                {tableauReinscriptions.ta.autre > 0 && (
                  <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>Autre <strong>{tableauReinscriptions.ta.autre}</strong></div>
                )}
                <div style={{ fontWeight: 'bold', color: '#1f2937', fontSize: '0.95rem' }}>
                  {formatMoney(tableauReinscriptions.ta.ca)} MAD
                </div>
              </div>
            </div>
          </div>

          <DesistementsComponent anneeScolaire={anneeScolaireFilter} />
          <MonthlyRevenueTracker anneeScolaire={anneeScolaireFilter} />

          {/* TABLE ÉDITABLE DES PARTENAIRES */}
          <div
            style={{
              background: '#fff',
              borderRadius: '8px',
              padding: '2rem',
              marginBottom: '2rem',
              border: '1px solid #e5e7eb'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
              <h2
                style={{
                  fontSize: '1.25rem',
                  fontWeight: 'bold',
                  color: '#1f2937',
                  margin: 0,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                <Handshake size={24} />
                Détails des Partners {anneeScolaireFilter}
              </h2>
              <button
                onClick={() => {
                  const name = prompt('Nom du partenaire:');
                  if (name) {
                    createPartnerChiffre({
                      name,
                      students: 0,
                      revenue: 0,
                      realisation: 0,
                      paymentSchedule: '',
                      anneeScolaire: anneeScolaireFilter
                    });
                  }
                }}
                style={{
                  background: '#059669',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '0.75rem 1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                <Plus size={18} />
                Ajouter
              </button>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #e5e7eb', background: '#f9fafb' }}>
                  <th rowSpan={2} style={{ padding: '1rem', textAlign: 'left', fontWeight: '700', borderRight: '1px solid #e5e7eb' }}>Partenaire</th>
                  <th colSpan={2} style={{ padding: '0.5rem', textAlign: 'center', fontWeight: '700', borderRight: '1px solid #e5e7eb' }}>Objectif</th>
                  <th colSpan={2} style={{ padding: '0.5rem', textAlign: 'center', fontWeight: '700', borderRight: '1px solid #e5e7eb' }}>Réalisation</th>
                  <th colSpan={2} style={{ padding: '0.5rem', textAlign: 'center', fontWeight: '700', borderRight: '1px solid #e5e7eb' }}>Écart</th>
                  <th rowSpan={2} style={{ padding: '1rem', textAlign: 'center', fontWeight: '700' }}>Actions</th>
                </tr>
                <tr style={{ borderBottom: '2px solid #e5e7eb', background: '#f9fafb' }}>
                  <th style={{ padding: '0.5rem', textAlign: 'center', fontWeight: '600', fontSize: '0.85rem', borderRight: '1px solid #e5e7eb' }}>Nbr. Étudiants</th>
                  <th style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '600', fontSize: '0.85rem', borderRight: '1px solid #e5e7eb' }}>CA</th>
                  <th style={{ padding: '0.5rem', textAlign: 'center', fontWeight: '600', fontSize: '0.85rem', borderRight: '1px solid #e5e7eb' }}>Nbr. Étudiants</th>
                  <th style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '600', fontSize: '0.85rem', borderRight: '1px solid #e5e7eb' }}>CA</th>
                  <th style={{ padding: '0.5rem', textAlign: 'center', fontWeight: '600', fontSize: '0.85rem', borderRight: '1px solid #e5e7eb' }}>Nbr. Étudiants</th>
                  <th style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '600', fontSize: '0.85rem' }}>CA</th>
                </tr>
              </thead>
              <tbody>
                {getUnifiedPartnersList().map((partner) => {
                  const isEditing = editingPartnerId === partner._id;
                  return (
                    <tr key={partner._id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                      {isEditing ? (
                        <>
                          <td style={{ padding: '0.75rem', borderRight: '1px solid #e5e7eb' }}>
                            <input
                              value={editValues.name !== undefined ? editValues.name : partner.name}
                              onChange={(e) => setEditValues({ ...editValues, name: e.target.value })}
                              style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
                            />
                          </td>
                          <td style={{ padding: '0.75rem', borderRight: '1px solid #e5e7eb' }}>
                            <input
                              type="number"
                              value={editValues.students !== undefined ? editValues.students : partner.targetStudents}
                              onChange={(e) => {
                                const val = parseInt(e.target.value) || 0;
                                const currentRealised = editValues.realisedStudents !== undefined ? editValues.realisedStudents : partner.realisedStudents;
                                setEditValues({
                                  ...editValues,
                                  students: val,
                                  ecartStudents: currentRealised - val
                                });
                              }}
                              style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', textAlign: 'center' }}
                            />
                          </td>
                          <td style={{ padding: '0.75rem', borderRight: '1px solid #e5e7eb' }}>
                            <input
                              type="number"
                              value={editValues.revenue !== undefined ? editValues.revenue : partner.targetCA}
                              onChange={(e) => {
                                const val = parseFloat(e.target.value) || 0;
                                const currentRealised = editValues.realisation !== undefined ? editValues.realisation : partner.realisedCA;
                                setEditValues({
                                  ...editValues,
                                  revenue: val,
                                  ecartCA: currentRealised - val
                                });
                              }}
                              style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', textAlign: 'right' }}
                            />
                          </td>
                          <td style={{ padding: '0.75rem', borderRight: '1px solid #e5e7eb' }}>
                            <input
                              type="number"
                              value={editValues.realisedStudents !== undefined ? editValues.realisedStudents : partner.realisedStudents}
                              onChange={(e) => {
                                const val = parseInt(e.target.value) || 0;
                                const currentObj = editValues.students !== undefined ? editValues.students : partner.targetStudents;
                                setEditValues({
                                  ...editValues,
                                  realisedStudents: val,
                                  ecartStudents: val - currentObj
                                });
                              }}
                              style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', textAlign: 'center' }}
                            />
                          </td>
                          <td style={{ padding: '0.75rem', textAlign: 'right', borderRight: '1px solid #e5e7eb' }}>
                            <input
                              type="number"
                              value={editValues.realisation !== undefined ? editValues.realisation : partner.realisedCA}
                              onChange={(e) => {
                                const val = parseFloat(e.target.value) || 0;
                                const currentObj = editValues.revenue !== undefined ? editValues.revenue : partner.targetCA;
                                setEditValues({
                                  ...editValues,
                                  realisation: val,
                                  ecartCA: val - currentObj
                                });
                              }}
                              style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', textAlign: 'right' }}
                            />
                          </td>
                          <td style={{ padding: '0.75rem', borderRight: '1px solid #e5e7eb' }}>
                            <input
                              type="number"
                              value={editValues.ecartStudents !== undefined ? editValues.ecartStudents : partner.ecartStudents}
                              onChange={(e) => setEditValues({ ...editValues, ecartStudents: parseInt(e.target.value) || 0 })}
                              style={{
                                width: '100%',
                                padding: '0.5rem',
                                border: '1px solid #d1d5db',
                                borderRadius: '4px',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                color: (editValues.ecartStudents !== undefined ? editValues.ecartStudents : partner.ecartStudents) >= 0 ? '#15803d' : '#b91c1c'
                              }}
                            />
                          </td>
                          <td style={{ padding: '0.75rem' }}>
                            <input
                              type="number"
                              value={editValues.ecartCA !== undefined ? editValues.ecartCA : partner.ecartCA}
                              onChange={(e) => setEditValues({ ...editValues, ecartCA: parseFloat(e.target.value) || 0 })}
                              style={{
                                width: '100%',
                                padding: '0.5rem',
                                border: '1px solid #d1d5db',
                                borderRadius: '4px',
                                textAlign: 'right',
                                fontWeight: 'bold',
                                color: (editValues.ecartCA !== undefined ? editValues.ecartCA : partner.ecartCA) >= 0 ? '#15803d' : '#b91c1c'
                              }}
                            />
                          </td>
                          <td style={{ padding: '0.75rem', display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
                            <button
                              onClick={() => {
                                if (partner.manualEntry) {
                                  updatePartnerChiffre(partner.manualEntry._id, editValues);
                                } else {
                                  createPartnerChiffre({
                                    name: editValues.name !== undefined ? editValues.name : partner.name,
                                    students: editValues.students !== undefined ? editValues.students : partner.targetStudents,
                                    revenue: editValues.revenue !== undefined ? editValues.revenue : partner.targetCA,
                                    realisation: editValues.realisation !== undefined ? editValues.realisation : partner.realisedCA,
                                    realisedStudents: editValues.realisedStudents !== undefined ? editValues.realisedStudents : partner.realisedStudents,
                                    ecartStudents: editValues.ecartStudents !== undefined ? editValues.ecartStudents : partner.ecartStudents,
                                    ecartCA: editValues.ecartCA !== undefined ? editValues.ecartCA : partner.ecartCA,
                                    paymentSchedule: editValues.paymentSchedule !== undefined ? editValues.paymentSchedule : partner.paymentSchedule,
                                    anneeScolaire: anneeScolaireFilter
                                  });
                                  setEditingPartnerId(null);
                                }
                              }}
                              style={{ background: '#059669', color: 'white', border: 'none', borderRadius: '4px', padding: '0.5rem 0.75rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
                            >
                              <Save size={16} />
                            </button>
                            <button
                              onClick={() => setEditingPartnerId(null)}
                              style={{ background: '#ef4444', color: 'white', border: 'none', borderRadius: '4px', padding: '0.5rem 0.75rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
                            >
                              <X size={16} />
                            </button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td style={{ padding: '1rem', fontWeight: 'bold', borderRight: '1px solid #e5e7eb' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                              {partner.name}
                              {partner.autoEntry && (
                                <span title="Données réelles issues de la base de données" style={{ cursor: 'help', fontSize: '1rem' }}>📊</span>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: '1rem', textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>
                            <span style={{ background: '#dbeafe', color: '#1e40af', padding: '0.375rem 0.875rem', borderRadius: '9999px', fontWeight: 'bold' }}>
                              {partner.targetStudents}
                            </span>
                          </td>
                          <td style={{ padding: '1rem', textAlign: 'right', fontWeight: 'bold', borderRight: '1px solid #e5e7eb' }}>
                            {formatMoney(partner.targetCA)}
                          </td>
                          <td style={{ padding: '1rem', textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>
                            <span style={{ background: '#dcfce7', color: '#166534', padding: '0.375rem 0.875rem', borderRadius: '9999px', fontWeight: 'bold' }}>
                              {partner.realisedStudents}
                            </span>
                          </td>
                          <td style={{ padding: '1rem', textAlign: 'right', fontWeight: 'bold', borderRight: '1px solid #e5e7eb', color: '#047857' }}>
                            {formatMoney(partner.realisedCA)}
                          </td>
                          <td style={{
                            padding: '1rem',
                            textAlign: 'center',
                            borderRight: '1px solid #e5e7eb',
                            fontWeight: 'bold',
                            color: partner.ecartStudents >= 0 ? '#15803d' : '#b91c1c'
                          }}>
                            {partner.ecartStudents}
                          </td>
                          <td style={{
                            padding: '1rem',
                            textAlign: 'right',
                            fontWeight: 'bold',
                            color: partner.ecartCA >= 0 ? '#15803d' : '#b91c1c'
                          }}>
                            {formatMoney(partner.ecartCA)}
                          </td>
                          <td style={{ padding: '1rem', display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
                            <button
                              onClick={() => {
                                setEditingPartnerId(partner._id);
                                setEditValues({
                                  name: partner.name,
                                  students: partner.targetStudents,
                                  revenue: partner.targetCA,
                                  realisedStudents: partner.realisedStudents,
                                  realisation: partner.realisedCA,
                                  ecartStudents: partner.ecartStudents,
                                  ecartCA: partner.ecartCA,
                                  paymentSchedule: partner.paymentSchedule
                                });
                              }}
                              style={{ background: '#3b82f6', color: 'white', border: 'none', borderRadius: '4px', padding: '0.5rem 0.75rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
                            >
                              <Edit2 size={16} />
                            </button>
                            {partner.manualEntry && (
                              <button
                                onClick={() => deletePartnerChiffre(partner.manualEntry._id)}
                                style={{ background: '#ef4444', color: 'white', border: 'none', borderRadius: '4px', padding: '0.5rem 0.75rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
                              >
                                <Trash2 size={16} />
                              </button>
                            )}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                {(() => {
                  const list = getUnifiedPartnersList();
                  const totalObjStudents = list.reduce((sum, p) => sum + p.targetStudents, 0);
                  const totalObjCA = list.reduce((sum, p) => sum + p.targetCA, 0);
                  const totalRealisedStudents = list.reduce((sum, p) => sum + p.realisedStudents, 0);
                  const totalRealisedCA = list.reduce((sum, p) => sum + p.realisedCA, 0);
                  const totalEcartStudents = list.reduce((sum, p) => sum + p.ecartStudents, 0);
                  const totalEcartCA = list.reduce((sum, p) => sum + p.ecartCA, 0);

                  return (
                    <tr style={{ background: '#f0fdf4', borderTop: '2px solid #22c55e', fontWeight: 'bold', color: '#15803d' }}>
                      <td style={{ padding: '1rem', fontWeight: 'bold', borderRight: '1px solid #e5e7eb' }}>
                        Total ({list.length} partenaires)
                      </td>
                      <td style={{ padding: '1rem', textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>
                        {totalObjStudents}
                      </td>
                      <td style={{ padding: '1rem', textAlign: 'right', borderRight: '1px solid #e5e7eb' }}>
                        {formatMoney(totalObjCA)} MAD
                      </td>
                      <td style={{ padding: '1rem', textAlign: 'center', borderRight: '1px solid #e5e7eb' }}>
                        {totalRealisedStudents}
                      </td>
                      <td style={{ padding: '1rem', textAlign: 'right', borderRight: '1px solid #e5e7eb' }}>
                        {formatMoney(totalRealisedCA)} MAD
                      </td>
                      <td style={{
                        padding: '1rem',
                        textAlign: 'center',
                        borderRight: '1px solid #e5e7eb',
                        color: totalEcartStudents >= 0 ? '#15803d' : '#b91c1c'
                      }}>
                        {totalEcartStudents}
                      </td>
                      <td style={{
                        padding: '1rem',
                        textAlign: 'right',
                        color: totalEcartCA >= 0 ? '#15803d' : '#b91c1c'
                      }}>
                        {formatMoney(totalEcartCA)} MAD
                      </td>
                      <td style={{ padding: '1rem' }}></td>
                    </tr>
                  );
                })()}
              </tfoot>
            </table>
          </div>

          <MonthlyInscriptionsTracker anneeScolaire={anneeScolaireFilter} />

          <TdbPedagogiqueComponent
            anneeScolaire={anneeScolaireFilter}
            etudiants={etudiants}
          />

          <CommissionsCommercialesComponent
            anneeScolaire={anneeScolaireFilter}
            etudiants={etudiants}
            commerciaux={commerciaux}
          />

          <ActivitesManagement anneeScolaire={anneeScolaireFilter} />

          {/* Performance des Commerciaux */}
          <div
            style={{
              background: '#fff',
              borderRadius: '8px',
              padding: '2rem',
              marginBottom: '2rem',
              border: '1px solid #e5e7eb'
            }}
          >
            <h2
              style={{
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#1f2937',
                marginBottom: '2rem',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              <Users size={24} />
              Performance des Commerciaux {anneeScolaireFilter === 'toutes' ? '' : anneeScolaireFilter}
            </h2>

            {statistiques.length > 0 ? (
              <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
                  <thead style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                    <tr>
                      <th style={{
                        padding: '1rem 1.25rem',
                        textAlign: 'left',
                        fontWeight: '700',
                        color: '#374151',
                        fontSize: '0.875rem',
                        borderBottom: '2px solid #e5e7eb'
                      }}>Commercial</th>
                      <th style={{
                        padding: '1rem 1.25rem',
                        textAlign: 'left',
                        fontWeight: '700',
                        color: '#374151',
                        fontSize: '0.875rem',
                        borderBottom: '2px solid #e5e7eb'
                      }}>Contact</th>
                      <th style={{
                        padding: '1rem 1.25rem',
                        textAlign: 'left',
                        fontWeight: '700',
                        color: '#374151',
                        fontSize: '0.875rem',
                        borderBottom: '2px solid #e5e7eb'
                      }}>Étudiants</th>
                      <th style={{
                        padding: '1rem 1.25rem',
                        textAlign: 'left',
                        fontWeight: '700',
                        color: '#374151',
                        fontSize: '0.875rem',
                        borderBottom: '2px solid #e5e7eb'
                      }}>Chiffre d'Affaires</th>

                      <th style={{
                        padding: '1rem 1.25rem',
                        textAlign: 'left',
                        fontWeight: '700',
                        color: '#374151',
                        fontSize: '0.875rem',
                        borderBottom: '2px solid #e5e7eb'
                      }}>Montant Reçu</th>
                      <th style={{
                        padding: '1rem 1.25rem',
                        textAlign: 'left',
                        fontWeight: '700',
                        color: '#374151',
                        fontSize: '0.875rem',
                        borderBottom: '2px solid #e5e7eb'
                      }}>Reste à Payer</th>
                      <th style={{
                        padding: '1rem 1.25rem',
                        textAlign: 'left',
                        fontWeight: '700',
                        color: '#374151',
                        fontSize: '0.875rem',
                        borderBottom: '2px solid #e5e7eb'
                      }}>Taux Recouvrement</th>
                    </tr>
                  </thead>
                  <tbody>
                    {statistiques.map((stat, index) => {
                      const tauxRecouvrement = stat.chiffreAffaire > 0
                        ? ((stat.totalRecu / stat.chiffreAffaire) * 100).toFixed(1)
                        : 0;

                      return (
                        <tr key={index} style={{
                          borderBottom: '1px solid #f3f4f6',
                          opacity: stat.actif ? 1 : 0.6
                        }}>
                          <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                              <div style={{
                                width: '2.5rem',
                                height: '2.5rem',
                                background: '#e5e7eb',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#6b7280'
                              }}>
                                <User size={20} />
                              </div>
                              <div>
                                <div style={{ fontWeight: '600', color: '#1e293b' }}>{stat.nom}</div>
                                {stat.estAdminInscription && (
                                  <div style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '0.25rem',
                                    background: '#dbeafe',
                                    color: '#1e40af',
                                    padding: '0.125rem 0.5rem',
                                    borderRadius: '0.375rem',
                                    fontSize: '0.75rem',
                                    fontWeight: '600',
                                    marginTop: '0.25rem'
                                  }}>
                                    <Shield size={12} />
                                    Admin
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                              {stat.email && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', color: '#64748b' }}>
                                  <Mail size={14} />
                                  <span>{stat.email}</span>
                                </div>
                              )}
                              {stat.telephone && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', color: '#64748b' }}>
                                  <Phone size={14} />
                                  <span>{stat.telephone}</span>
                                </div>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle' }}>
                            <span style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '0.375rem 0.875rem',
                              borderRadius: '9999px',
                              fontSize: '0.875rem',
                              fontWeight: '600',
                              color: 'white',
                              background: '#3b82f6',
                              minWidth: '2rem'
                            }}>
                              {stat.countEtudiants || 0}
                            </span>
                          </td>
                          <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                              <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#059669' }}>
                                {stat.nouveaux || 0} nouveaux
                              </span>
                              <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#3b82f6' }}>
                                {stat.reinscriptions || 0} réinscr.
                              </span>
                              {stat.countEtudiants > 0 && (
                                <span style={{ fontSize: '0.75rem', color: '#64748b' }}>
                                  ({(((stat.nouveaux || 0) / stat.countEtudiants) * 100).toFixed(1)}% nouveaux)
                                </span>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle', textAlign: 'right' }}>
                            <span style={{
                              fontFamily: 'SF Mono, Monaco, Cascadia Code, monospace',
                              fontSize: '0.9rem',
                              fontWeight: '600',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '0.375rem',
                              background: 'rgba(59, 130, 246, 0.1)',
                              color: '#1d4ed8'
                            }}>
                              {(stat.chiffreAffaire || 0).toLocaleString('fr-FR')} MAD
                            </span>
                          </td>
                          <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle', textAlign: 'right' }}>
                            <span style={{
                              fontFamily: 'SF Mono, Monaco, Cascadia Code, monospace',
                              fontSize: '0.9rem',
                              fontWeight: '600',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '0.375rem',
                              background: 'rgba(16, 185, 129, 0.1)',
                              color: '#047857'
                            }}>
                              {(stat.totalRecu || 0).toLocaleString('fr-FR')} MAD
                            </span>
                          </td>
                          <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle', textAlign: 'right' }}>
                            <span style={{
                              fontFamily: 'SF Mono, Monaco, Cascadia Code, monospace',
                              fontSize: '0.9rem',
                              fontWeight: '600',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '0.375rem',
                              background: (stat.reste || 0) > 0 ? 'rgba(239, 68, 68, 0.1)' : 'rgba(16, 185, 129, 0.1)',
                              color: (stat.reste || 0) > 0 ? '#dc2626' : '#047857'
                            }}>
                              {(stat.reste || 0).toLocaleString('fr-FR')} MAD
                            </span>
                          </td>
                          <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                              <div style={{
                                flex: 1,
                                height: '8px',
                                background: '#e5e7eb',
                                borderRadius: '4px',
                                overflow: 'hidden'
                              }}>
                                <div
                                  style={{
                                    height: '100%',
                                    borderRadius: '4px',
                                    transition: 'width 0.3s ease',
                                    width: `${Math.min(tauxRecouvrement, 100)}%`,
                                    background: tauxRecouvrement >= 70 ? 'linear-gradient(90deg, #10b981, #059669)' :
                                      tauxRecouvrement >= 40 ? 'linear-gradient(90deg, #f59e0b, #d97706)' :
                                        'linear-gradient(90deg, #ef4444, #dc2626)'
                                  }}
                                ></div>
                              </div>
                              <span style={{
                                fontSize: '0.875rem',
                                fontWeight: '600',
                                color: '#64748b',
                                minWidth: '3rem',
                                textAlign: 'right'
                              }}>
                                {tauxRecouvrement}%
                              </span>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    {(() => {
                      const totalEtudiants = statistiques.reduce((sum, s) => sum + (s.countEtudiants || 0), 0);
                      const totalNouveaux = statistiques.reduce((sum, s) => sum + (s.nouveaux || 0), 0);
                      const totalReinscrits = statistiques.reduce((sum, s) => sum + (s.reinscriptions || 0), 0);
                      const totalCA = statistiques.reduce((sum, s) => sum + (s.chiffreAffaire || 0), 0);
                      const totalRecu = statistiques.reduce((sum, s) => sum + (s.totalRecu || 0), 0);
                      const totalReste = statistiques.reduce((sum, s) => sum + (s.reste || 0), 0);
                      const globalRecouvrement = totalCA > 0 ? ((totalRecu / totalCA) * 100).toFixed(1) : 0;

                      return (
                        <tr style={{ background: '#f8fafc', borderTop: '2px solid #e5e7eb', fontWeight: 'bold' }}>
                          <td colSpan={2} style={{ padding: '1rem 1.25rem', color: '#1e293b' }}>
                            Total ({statistiques.length} commerciaux)
                          </td>
                          <td style={{ padding: '1rem 1.25rem' }}>
                            <span style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '0.375rem 0.875rem',
                              borderRadius: '9999px',
                              fontSize: '0.875rem',
                              fontWeight: '700',
                              color: 'white',
                              background: '#1e40af'
                            }}>
                              {totalEtudiants}
                            </span>
                          </td>
                          <td style={{ padding: '1rem 1.25rem' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                              <span style={{ fontSize: '0.875rem', fontWeight: '700', color: '#059669' }}>
                                {totalNouveaux} nouveaux
                              </span>
                              <span style={{ fontSize: '0.875rem', fontWeight: '700', color: '#3b82f6' }}>
                                {totalReinscrits} réinscr.
                              </span>
                            </div>
                          </td>
                          <td style={{ padding: '1rem 1.25rem', textAlign: 'right', color: '#1d4ed8' }}>
                            {totalCA.toLocaleString('fr-FR')} MAD
                          </td>
                          <td style={{ padding: '1rem 1.25rem', textAlign: 'right', color: '#047857' }}>
                            {totalRecu.toLocaleString('fr-FR')} MAD
                          </td>
                          <td style={{ padding: '1rem 1.25rem', textAlign: 'right', color: '#dc2626' }}>
                            {totalReste.toLocaleString('fr-FR')} MAD
                          </td>
                          <td style={{ padding: '1rem 1.25rem', textAlign: 'right', color: '#475569' }}>
                            {globalRecouvrement}%
                          </td>
                        </tr>
                      );
                    })()}
                  </tfoot>
                </table>
              </div>
            ) : (
              <div style={{
                textAlign: 'center',
                color: '#94a3b8',
                fontStyle: 'italic',
                padding: '2rem'
              }}>
                Aucune donnée commerciale disponible pour cette année
              </div>
            )}
          </div>

          {/* Analyse Détaillée par Filière */}
          <div
            style={{
              background: '#fff',
              borderRadius: '8px',
              padding: '2rem',
              marginBottom: '2rem',
              border: '1px solid #e5e7eb'
            }}
          >
            <h2
              style={{
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#1f2937',
                marginBottom: '2rem',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              <BookOpen size={24} />
              Analyse Détaillée par Filière
            </h2>

            <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', fontSize: '0.9rem' }}>
                <thead style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                  <tr>
                    <th style={{
                      padding: '1rem 1.25rem',
                      textAlign: 'left',
                      fontWeight: '700',
                      color: '#374151',
                      fontSize: '0.875rem',
                      borderBottom: '2px solid #e5e7eb'
                    }}>Filière</th>
                    <th style={{
                      padding: '1rem 1.25rem',
                      textAlign: 'left',
                      fontWeight: '700',
                      color: '#374151',
                      fontSize: '0.875rem',
                      borderBottom: '2px solid #e5e7eb'
                    }}>Étudiants</th>
                    <th style={{
                      padding: '1rem 1.25rem',
                      textAlign: 'left',
                      fontWeight: '700',
                      color: '#374151',
                      fontSize: '0.875rem',
                      borderBottom: '2px solid #e5e7eb'
                    }}>Spécialités</th>
                    <th style={{
                      padding: '1rem 1.25rem',
                      textAlign: 'left',
                      fontWeight: '700',
                      color: '#374151',
                      fontSize: '0.875rem',
                      borderBottom: '2px solid #e5e7eb'
                    }}>Nouveaux/Réinscr.</th>
                    <th style={{
                      padding: '1rem 1.25rem',
                      textAlign: 'left',
                      fontWeight: '700',
                      color: '#374151',
                      fontSize: '0.875rem',
                      borderBottom: '2px solid #e5e7eb'
                    }}>Taux Paiement</th>
                    <th style={{
                      padding: '1rem 1.25rem',
                      textAlign: 'left',
                      fontWeight: '700',
                      color: '#374151',
                      fontSize: '0.875rem',
                      borderBottom: '2px solid #e5e7eb'
                    }}>CA Total</th>
                    <th style={{
                      padding: '1rem 1.25rem',
                      textAlign: 'left',
                      fontWeight: '700',
                      color: '#374151',
                      fontSize: '0.875rem',
                      borderBottom: '2px solid #e5e7eb'
                    }}>CA Payé</th>
                    <th style={{
                      padding: '1rem 1.25rem',
                      textAlign: 'left',
                      fontWeight: '700',
                      color: '#374151',
                      fontSize: '0.875rem',
                      borderBottom: '2px solid #e5e7eb'
                    }}>Prix Moyen</th>
                  </tr>
                </thead>
                <tbody>
                  {filieresData.map((filiere, index) => (
                    <tr key={index} style={{
                      borderBottom: '1px solid #f3f4f6',
                      transition: 'background-color 0.2s'
                    }}>
                      <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                          <span style={{ fontWeight: '700', color: '#1e293b', fontSize: '1rem' }}>
                            {filiere.filiere}
                          </span>
                          {filiere.specialitesCount > 0 && (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
                              {filiere.specialitesList.slice(0, 2).map((spec, i) => (
                                <span key={i} style={{
                                  background: '#dbeafe',
                                  color: '#1e40af',
                                  padding: '0.125rem 0.5rem',
                                  borderRadius: '0.375rem',
                                  fontSize: '0.75rem',
                                  fontWeight: '500'
                                }}>
                                  {spec}
                                </span>
                              ))}
                              {filiere.specialitesList.length > 2 && (
                                <span style={{
                                  background: '#f1f5f9',
                                  color: '#64748b',
                                  padding: '0.125rem 0.5rem',
                                  borderRadius: '0.375rem',
                                  fontSize: '0.75rem',
                                  fontWeight: '500'
                                }}>
                                  +{filiere.specialitesList.length - 2}
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      </td>
                      <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle' }}>
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '0.375rem 0.875rem',
                          borderRadius: '9999px',
                          fontSize: '0.875rem',
                          fontWeight: '600',
                          color: 'white',
                          background: '#6366f1',
                          minWidth: '2rem'
                        }}>
                          {filiere.total}
                        </span>
                      </td>
                      <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle' }}>
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '0.375rem 0.875rem',
                          borderRadius: '9999px',
                          fontSize: '0.875rem',
                          fontWeight: '600',
                          color: 'white',
                          background: '#8b5cf6',
                          minWidth: '2rem'
                        }}>
                          {filiere.specialitesCount}
                        </span>
                      </td>
                      <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                          <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#059669' }}>
                            {filiere.nouveaux} nouveaux
                          </span>
                          <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#3b82f6' }}>
                            {filiere.reinscriptions} réinscr.
                          </span>
                          <span style={{ fontSize: '0.75rem', color: '#64748b' }}>
                            ({filiere.tauxNouveaux}% nouveaux)
                          </span>
                        </div>
                      </td>
                      <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                          <div style={{
                            width: '100%',
                            height: '6px',
                            background: '#e5e7eb',
                            borderRadius: '3px',
                            overflow: 'hidden'
                          }}>
                            <div
                              style={{
                                height: '100%',
                                borderRadius: '3px',
                                transition: 'width 0.3s ease',
                                width: `${Math.min(filiere.tauxPaiement, 100)}%`,
                                background: parseFloat(filiere.tauxPaiement) >= 70 ? '#10b981' :
                                  parseFloat(filiere.tauxPaiement) >= 40 ? '#f59e0b' : '#ef4444'
                              }}
                            ></div>
                          </div>
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#1e293b' }}>
                            {filiere.tauxPaiement}%
                          </span>
                          <span style={{ fontSize: '0.75rem', color: '#64748b' }}>
                            ({filiere.payes} payés)
                          </span>
                        </div>
                      </td>
                      <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle', textAlign: 'right' }}>
                        <span style={{
                          fontFamily: 'SF Mono, Monaco, Cascadia Code, monospace',
                          fontSize: '0.9rem',
                          fontWeight: '600',
                          padding: '0.25rem 0.5rem',
                          borderRadius: '0.375rem',
                          background: 'rgba(59, 130, 246, 0.1)',
                          color: '#1d4ed8'
                        }}>
                          {formatMoney(filiere.ca)} MAD
                        </span>
                      </td>
                      <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle', textAlign: 'right' }}>
                        <span style={{
                          fontFamily: 'SF Mono, Monaco, Cascadia Code, monospace',
                          fontSize: '0.9rem',
                          fontWeight: '600',
                          padding: '0.25rem 0.5rem',
                          borderRadius: '0.375rem',
                          background: 'rgba(16, 185, 129, 0.1)',
                          color: '#047857'
                        }}>
                          {formatMoney(filiere.caPaye)} MAD
                        </span>
                      </td>
                      <td style={{ padding: '1rem 1.25rem', verticalAlign: 'middle', textAlign: 'right' }}>
                        <span style={{
                          fontFamily: 'SF Mono, Monaco, Cascadia Code, monospace',
                          fontSize: '0.9rem',
                          fontWeight: '600',
                          padding: '0.25rem 0.5rem',
                          borderRadius: '0.375rem',
                          background: 'rgba(139, 92, 246, 0.1)',
                          color: '#7c3aed'
                        }}>
                          {formatMoney(filiere.prixMoyen)} MAD
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Message d'erreur */}
          {error && (
            <div
              style={{
                background: '#fef2f2',
                border: '1px solid #fecaca',
                color: '#dc2626',
                padding: '1rem',
                borderRadius: '8px',
                marginTop: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              <AlertCircle size={20} />
              {error}
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @media (max-width: 1024px) {
          div[style*="grid-template-columns: repeat(4, 1fr)"] {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 768px) {
          div[style*="grid-template-columns: repeat(4, 1fr)"] {
            grid-template-columns: 1fr !important;
          }
          div[style*="grid-template-columns: repeat(2, 1fr)"] {
            grid-template-columns: 1fr !important;
          }
        }
        @media (max-width: 640px) {
          table { font-size: 0.8rem; }
          th, td { padding: 0.5rem !important; }
        }
      `}</style>
    </div>
  );
};

export default DashboardNormal;